export const it = {
    "login": "Accesso",
    "register": "Registrazione",
    "username": "Nome utente",
    "password": "Password",
    "email": "Email",
    "go-back": "Indietro",
    "EmailConfirmed_PleaseWait": "Email confermata. Attendere prego...",
    "EmailConfirmationErrorPage_Title": "Errore nella conferma dell'email",
    "EmailConfirmationErrorPage_Text": "Si è verificato un errore durante la conferma dell'email. Si prega di riprovare.",
    "EmailConfirmed_Success": "Email confermata con successo.",
    "The Username field is required.": "Il campo del nome utente è obbligatorio.",
    "The Email field is required.": "Il campo dell'email è obbligatorio.",
    "The Password field is required.": "Il campo della password è obbligatorio.",
    "EmailConfirmationErrorPage_BackButton": "Indietro",
    "redirector.unknownRoleForUsingApp": "Non ti è ancora stato assegnato l'accesso all'applicazione.",
    "NotFoundPage_Title": "Pagina non trovata",
    "NotFoundPage_BackButton": "Indietro",
    "NotFoundPage_Text": "La pagina che stai cercando non è stata trovata.",
    "ConfirmYourEmail": "Un link di conferma è stato inviato alla tua email. Si prega di confermare la tua email.",
    "User email not confirmed": "Email non confermata",
    "EmailNotConfirmed": "Email non confermata",
    "ResendConfirmationEmail": "Reinvia il link di conferma",
    "ResendConfirmationEmail_Success": "Il link di conferma è stato inviato con successo.",
    "PasswordTooShort": "La password è troppo corta.",
    "User not found": "Utente non trovato.",
    "back": "Indietro",
    "home": "Home",
    "logout": "Disconnetti",
    "users": "Utenti",
    "users-description": "Panoramica degli utenti",
    "organization-members": "Membri dell'organizzazione",
    "organization-members-description": "Gestione degli account organizzatori",
    "organization-member": "Membro dell'organizzazione",
    "add-organization-member": "Aggiungi membro",
    "resend-onboarding": "Reinvia onboarding",
    "pending-onboarding": "Onboarding in sospeso",
    "organization-member-created": "Membro dell'organizzazione creato",
    "organization-member-onboarding-sent": "Email di onboarding inviata",
    "administrator-only-page": "Questa pagina è disponibile solo per gli amministratori.",
    "administration": "Amministrazione",
    "error-loading-items": "Errore nel caricamento degli elementi",
    "search": "Ricerca",
    "clear-filter": "Pulisci filtro",
    "change-type": "Tipo modifica",
    "created-by": "Creato da",
    "created-between": "Creato tra",
    "state": "Stato",
    "created": "Creato",
    "changes": "Modifiche",
    "Previous": "Precedente",
    "Next": "Successivo",
    "create": "Aggiungi",
    "code": "Codice",
    "cancel": "Annulla",
    "save": "Salva",
    "id": "Chiave",
    "emailConfirmed": "Email confermata",
    "are-you-sure-you-want-to-delete-this-item": "Sei sicuro di voler eliminare questo elemento?",
    "delete": "Elimina",
    "page": "Pagina",
    "InvalidEmail": "Inserisci un'email valida",
    "additional": "Aggiuntivo",
    "resendConfirmationEmail": "Reinvia il link di conferma",
    "no-items": "Nessun elemento",
    "status": "Stato",
    "date": "Data",
    "roles": "Ruoli",
    "Admin": "Amministratore",
    "Customer": "Cliente",
    "taxId": "Partita IVA",
    "actions": "Azioni",
    "locations": "Ubicazioni",
    "address": "Indirizzo",
    "location-name": "Nome della ubicazione",
    "geodecode-address": "Cerca indirizzo sulla mappa",
    "import-locations": "Importa ubicazioni",
    "adding-users": "Aggiunta di utenti",
    "notification": "Notifica",
    "successfully-deleted-item": "Elemento eliminato con successo",
    "successfully-deleted-item-with-id": "Elemento con ID eliminato con successo",
    "error-deleting-item-with-id": "Errore nell'eliminazione dell'elemento con ID",
    "successfully-duplicated-item-with-id": "Elemento con ID duplicato con successo",
    "error-duplicating-item-with-id": "Errore nella duplicazione dell'elemento con ID",
    "company": "Azienda",
    "linkedin-url": "URL LinkedIn",
    "InvalidUserName": "Inserisci un nome utente valido",
    "editing-users": "Modifica degli utenti",
    "edit": "Modifica",
    "show-only-unassigned": "Mostra solo non assegnati",
    "settings": "Impostazioni",
    "start-search": "Avvia ricerca",
    "isMainLocation": "Ubicazione principale",
    "assign": "Assegna",
    "assigned-user": "Assegnato all'utente",
    "details": "Dettagli",
    "user": "Utente",
    "user-overview": "Panoramica dell'utente",
    "MANAGER": "Manager",
    "user-details": "Dettagli Utente",
    "confirmationEmailSent": "Email di conferma inviata",
    "userName": "Nome Utente",
    "firstName": "Nome",
    "lastName": "Cognome",
    "system": "Sistema",
    "basic-data": "Dati di Base",
    "role": "Ruolo",
    "languages-full:hr": "Croato",
    "languages-full:en": "Inglese",
    "languages-full:de": "Tedesco",
    "languages-full:it": "Italiano",
    "duplicate": "Duplica",
    "name": "Nome",
    "name-hr": "Nome (croato)",
    "name-en": "Nome (inglese)",
    "place": "Luogo",
    "description": "Descrizione",
    "event-information": "Informazioni sull'evento",
    "event-information-hr": "Informazioni sull'evento (croato)",
    "event-information-en": "Informazioni sull'evento (inglese)",
    "on-site-registration-instructions": "Istruzioni per la registrazione in sede",
    "on-site-registration-instructions-hr": "Istruzioni per la registrazione in sede (croato)",
    "on-site-registration-instructions-en": "Istruzioni per la registrazione in sede (inglese)",
    "nameAndDescription": "Nome e Descrizione",
    "NoResults": "Nessun Risultato",
    "dateTime": "Data e ora",
    "initiatingUser": "Iniziatore",
    "deactivated": "Disattivato",
    "parent": "Superiore",
    "parentId": "ID del superiore",
    "Email already exists": "L'email esiste già",
    "unassigned": "Non assegnato",
    "note": "Nota",
    "first-page": "Prima pagina",
    "next-page": "Pagina successiva",
    "previous-page": "Pagina precedente",
    "last-page": "Ultima pagina",
    "yes": "Sì",
    "no": "No",
    "warning": "Avviso",
    "phoneNumber": "Numero di telefono",
    "preferredLanguage": "Lingua Preferita",
    "enums:COMPLETED": "Completato",
    "enums:CANCELLED": "Annullato",
    "quantity": "Quantità",
    "add-row": "Aggiungi Riga",
    "header": "Intestazione",
    "basics": "Principi",
    "priority": "Priorità",
    "BackGoToLogin": "Torna al Login",
    "close": "Chiudi",
    "notes": "Note",
    "createdAt": "Data di Creazione",
    "error-occurred": "Si è verificato un errore",
    "reload": "Ricarica",
    "user-updated-successfully": "Utente aggiornato con successo",
    "profile-updated": "Profilo aggiornato",
    "location": "Posizione",
    "requested-by": "Richiesto da",
    "startDate": "Data di Inizio",
    "endDate": "Data di Fine",
    "count": "Conteggio",
    "xlsx_export": "Esporta in Excel",
    "csv_export": "Esporta in CSV",
    "current-page": "Pagina Corrente",
    "page-of": "di",
    "value": "Valore",
    "Login": "Accesso",
    "change-password": "Cambia password",
    "oldPassword": "Vecchia password",
    "newPassword": "Nuova password",
    "password-changed": "Password cambiata",
    "password-reset": "Reimposta password",
    "password-reset-successful": "Reimpostazione password riuscita",
    "no-data": "Nessun dato",
    "events-and-forms": "Eventi e configurazione iscrizioni",
    "attendees-and-registrations": "Partecipanti e iscrizioni",
    "finance": "Finanze",
    "resources": "Risorse",
    "events": "Eventi",
    "events-description": "Crea e gestisci eventi, pianificazioni e codici di accesso pubblicati.",
    "registration-forms": "Iscrizione pubblica",
    "registration-forms-description": "Condividi l'URL live di iscrizione pubblica per ogni evento.",
    "accommodations": "Alloggi",
    "accommodations-description": "Gestisci le opzioni di alloggio collegate agli eventi.",
    "room-allotments": "Contingenti camere",
    "room-allotments-description": "Assegna blocchi di camere e monitora la disponibilità per notte.",
    "participants": "Partecipanti",
    "participants-description": "Visualizza e gestisci le persone che partecipano agli eventi.",
    "registrations": "Iscrizioni",
    "registrations-description": "Rivedi le iscrizioni dei partecipanti, gli stati e gli alloggi assegnati.",
    "notifications": "Notifiche",
    "notifications-description": "Consulta la cronologia di consegna email degli organizzatori.",
    "general-settings": "Impostazioni generali",
    "general-settings-description": "Gestisci beneficiario e impostazioni fiscali predefinite.",
    "public-event-forms": "Condividi iscrizione live",
    "public-event-forms-description": "Condividi l'URL pubblico ospitato e l'iframe. Le modifiche del setup appaiono subito.",
    "public-registration-share": "Condivisione iscrizione pubblica",
    "public-registration-share-description": "Usa l'URL ospitato per un normale link WordPress oppure copia lo snippet iframe per un embed consentito.",
    "recipient-email": "Email destinatario",
    "sent-by": "Inviato da",
    "sent-at": "Inviato il",
    "failed-at": "Errore il",
    "failure-message": "Messaggio di errore",
    "notification-history-count": "{{count}} record di consegna",
    "select-event-to-view-notifications": "Seleziona un evento per visualizzare la cronologia notifiche.",
    "notification-status:SENT": "Inviato",
    "notification-status:FAILED": "Non riuscito",
    "notification-status:DRAFT": "Bozza",
    "cta.new-event": "Nuovo evento",
    "cta.view-schedule": "Visualizza programma",
    "cta.preview-form": "Anteprima modulo",
    "cta.new-accommodation": "Nuova struttura",
    "cta.manage-room-types": "Gestisci tipologie di camera",
    "cta.new-room-allotment": "Nuova allocazione camere",
    "cta.adjust-allotment": "Regola allocazione",
    "cta.new-participant": "Aggiungi partecipante",
    "cta.import-participants": "Importa partecipanti",
    "cta.new-registration": "Aggiungi iscrizione",
    "cta.assign-accommodation": "Assegna alloggio",
    "cta.view-public-form": "Apri modulo pubblico",
    "cta.copy-public-link": "Copia link pubblico",
    "cta.save": "Salva",
    "cta.edit-definition": "Modifica definizione",
    "start-date": "Data inizio",
    "end-date": "Data fine",
    "capacity": "Capienza",
    "beds": "Letti",
    "rooms": "Camere",
    "assigned": "Assegnato",
    "remaining": "Rimanenti",
    "total-rooms": "Totale camere",
    "version": "Versione",
    "fields": "Campi",
    "event": "Evento",
    "participant": "Partecipante",
    "group": "Gruppo",
    "members": "Membri",
    "balance": "Saldo",
    "payer": "Pagatore",
    "reference": "Riferimento",
    "payment": "Pagamento",
    "target": "Destinazione",
    "amount": "Importo",
    "linked-to": "Collegato a",
    "filters": "Filtri",
    "filter.event": "Evento",
    "event-drilldown": "Parti dall'evento",
    "cta.view-registrations": "Iscrizioni",
    "cta.view-rooming": "Alloggi",
    "cta.view-forms": "Moduli",
    "method": "Metodo",
    "paid-at": "Pagato il",
    "packageCode": "Codice pacchetto",
    "logo-url": "File logo evento",
    "program-pdf-url": "File PDF programma",
    "venue-layout-image-url": "File immagine mappa sede",
    "sponsors-image-url": "File immagine sponsor",
    "primary-color": "Colore primario",
    "secondary-color": "Colore secondario",
    "badge-template-url": "File grafica badge",
    "certificate-template-url": "File modello certificato",
    "certificate-name-x": "Posizionamento nome - offset orizzontale",
    "certificate-name-y": "Posizionamento nome - offset verticale",
    "validation.color-required": "{{field}} è obbligatorio.",
    "validation.hex-color": "{{field}} deve essere un colore HEX come #223F6B.",
    "validation.field-required": "{{field}} è obbligatorio.",
    "validation.required-field": "Campo obbligatorio",
    "validation.number": "{{field}} deve essere un numero.",
    "price-period-start-date-required": "La data di inizio è obbligatoria.",
    "price-period-end-date-required": "La data di fine è obbligatoria.",
    "price-period-end-before-start": "La data di fine deve essere uguale o successiva alla data di inizio.",
    "price-period-overlap": "I periodi di prezzo non possono sovrapporsi. Questo intervallo si sovrappone a {{period}} ({{startDate}} - {{endDate}}).",
    "organizerName": "Organizzatore",
    "sponsorName": "Sponsor",
    "about-app-changelog": "Novità",
    "about-app-description": "EventFlow aiuta gli organizzatori a preparare gli eventi, gestire le iscrizioni dei partecipanti e lavorare in loco.",
    "about-app-error": "Le informazioni sulla versione non sono al momento disponibili.",
    "about-app-title": "Informazioni sull'app",
    "about-app-version": "Versione",
    "accommodation": "Alloggio",
    "accommodation-choice": "Alloggio selezionato",
    "accommodation-offer": "Offerta alloggio",
    "accommodation-offer-total": "Totale alloggio: {{amount}}",
    "accommodation-payment": "Pagamento alloggio",
    "accommodation-payment-not-issued": "Non emesso",
    "accommodation-payment-status": "Stato pagamento alloggio",
    "accommodation-ppo": "PPO alloggio",
    "accommodation-ppo-default": "PPO predefinita alloggio",
    "accommodation-ppo-required": "La PPO alloggio è obbligatoria.",
    "accommodation-reservations": "Prenotazioni alloggio",
    "accommodation-reserved": "Prenotato",
    "accommodation-tax-scheme": "Regime fiscale alloggio",
    "accommodation-vat": "PPO alloggio",
    "accommodation-vat-default": "PPO predefinita alloggio",
    "accommodation-vat-required": "La PPO alloggio è obbligatoria.",
    "action": "Azione",
    "active": "Attivo",
    "active-codes": "Codici attivi",
    "active-codes-count": "{{count}} codici attivi",
    "active-events": "Eventi attivi",
    "activities": "Attività",
    "activity-allowed-fee-types": "Tipi di quota partecipante ammessi",
    "activity-public-registration-end-date": "Termine iscrizione all'attività",
    "activity-tracks-usage-or-attendance": "Monitorare utilizzo/presenza?",
    "activity-visibility-rule": "Regola di visibilità",
    "activity-visible-after-activity": "Visibile dopo l'attività",
    "activity-visible-after-answer": "Risposta attesa",
    "additional-info": "Aggiuntivo",
    "address-required": "L'indirizzo è obbligatorio.",
    "all": "Tutti",
    "all-payers": "Tutti i paganti",
    "allocated-amount": "Allocato",
    "amount-gross": "Importo lordo",
    "amount-net": "Importo netto",
    "app-channel-not-active": "App non attiva",
    "apply-filters": "Applica filtri",
    "archive": "Archivio",
    "archive-description": "Consulta gli eventi archiviati e lo storico operativo.",
    "archive-state": "Stato archivio",
    "archived": "Archiviato",
    "archived-at": "Archiviato il",
    "archived-event": "Evento archiviato",
    "archived-events": "Eventi archiviati",
    "archived-events-count": "{{count}} eventi archiviati",
    "are-you-sure-you-want-to-delete-selected-items": "Eliminare davvero gli elementi selezionati?",
    "arrival": "Arrivo",
    "asset-mode-combined-pdf": "Un PDF",
    "asset-mode-separate-program-layout": "Programma + mappa",
    "ati-logo-alt": "Logo ATI",
    "back-to-participants": "Torna ai partecipanti",
    "badge-template-back-file": "File grafica retro dell'accredito",
    "badge-template-front-file": "File grafica fronte dell'accredito",
    "badge-template.back": "Retro",
    "badge-template.back-empty": "Carica la grafica del retro per visualizzare la posizione del QR.",
    "badge-template.back-preview-alt": "Anteprima retro dell'accredito",
    "badge-template.editor": "Editor visivo dell'accredito",
    "badge-template.first-name": "Nome",
    "badge-template.front": "Fronte",
    "badge-template.front-empty": "Carica la grafica del fronte per visualizzarne la disposizione.",
    "badge-template.front-preview-alt": "Anteprima fronte dell'accredito",
    "badge-template.incomplete": "Incompleto",
    "badge-template.institution": "Istituzione",
    "badge-template.last-name": "Cognome",
    "badge-template.load-error": "Modello di accredito non disponibile",
    "badge-template.qr-code": "Codice QR",
    "badge-template.ready": "Pronto",
    "badge-template.saved": "Modello di accredito salvato",
    "badge-template.title": "Modello di accredito",
    "body": "Contenuto",
    "branding-and-assets": "Branding e grafiche",
    "branding-assets-certificate": "Branding, documenti e attestato",
    "category": "Categoria",
    "category-codes": "Codici categoria",
    "certificate": "Attestato",
    "certificate-count": "{{count}} attestati",
    "certificate-document": "Documento attestato",
    "certificate-eligibility": "Idoneità attestato",
    "certificate-email-queue-failed": "Impossibile mettere in coda l'email dell'attestato.",
    "certificate-email-queued": "Email dell'attestato in coda.",
    "certificate-event-completion-required": "Disponibile dopo la conclusione dell'evento",
    "certificate-generated": "Attestato pronto",
    "certificate-generation-failed": "Impossibile generare l'attestato",
    "certificate-history": "Storico attestati",
    "certificate-issued": "Emesso",
    "certificate-issued-filter": "Emesso",
    "certificate-not-eligible": "Non pronto",
    "certificate-not-ready": "Non pronto",
    "certificate-pdf": "PDF attestato",
    "certificate-ready": "Pronto",
    "certificate-registered-status": "Pronto",
    "certificate-request-description": "Al termine dell'evento usa il link del tuo invito QR per richiedere l'attestato.",
    "certificate-request-load-failed": "Impossibile caricare i dati dell'iscrizione.",
    "certificate-request-missing-token": "Nel link di richiesta dell'attestato manca il token di iscrizione.",
    "certificate-request-submit-failed": "Impossibile inviare la richiesta di attestato.",
    "certificate-request-success": "Richiesta di attestato ricevuta.",
    "certificate-request-title": "Richiesta di attestato",
    "certificate-state": "Stato attestato",
    "certificate-template-file": "File modello attestato",
    "certificate-template.editor": "Editor visivo dell'attestato",
    "certificate-template.empty": "Carica un modello di attestato per visualizzare la disposizione.",
    "certificate-template.incomplete": "Incompleto",
    "certificate-template.load-error": "Modello di attestato non disponibile",
    "certificate-template.participant-name": "Nome del partecipante",
    "certificate-template.preview-alt": "Anteprima modello attestato",
    "certificate-template.ready": "Pronto",
    "certificate-template.saved": "Modello di attestato salvato",
    "certificate-template.title": "Modello di attestato",
    "certificates": "attestati",
    "check-in.badge-download-failed": "Impossibile generare l'accredito.",
    "check-in.badge-download-missing": "Scansiona prima un codice valido.",
    "check-in.badge-downloaded": "Accredito pronto per la stampa scaricato.",
    "check-in.badge-missing": "Mancante",
    "check-in.badge-ready": "Pronto",
    "check-in.download-badge": "Scarica accredito",
    "check-in.failure-message": "Nota sul problema di stampa",
    "check-in.failure-message-required": "La nota sul problema di stampa è obbligatoria.",
    "check-in.outcome.blocked": "Non idoneo",
    "check-in.outcome.eligible": "Pronto per la stampa",
    "check-in.outcome.invalid": "Codice non valido",
    "check-in.outcome.revoked": "Codice revocato",
    "check-in.outcome.unknown": "Stato sconosciuto",
    "check-in.outcome.wrong-event": "Evento errato",
    "check-in.print-failed": "Stampa non riuscita",
    "check-in.print-failure-failed": "Impossibile registrare il problema di stampa.",
    "check-in.print-failure-recorded": "Problema di stampa registrato.",
    "check-in.print-recorded": "Esito della stampa registrato.",
    "check-in.print-result-missing": "Scansiona prima un codice valido e inserisci il nome della postazione.",
    "check-in.print-status": "Stato stampa",
    "check-in.print-succeeded": "Stampa riuscita",
    "check-in.print-success-failed": "Impossibile registrare la stampa riuscita.",
    "check-in.print-success-recorded": "Stampa riuscita registrata.",
    "check-in.registration-code-token": "Token del codice di iscrizione",
    "check-in.registration-updated": "Iscrizione spostata nello stato Registrato.",
    "check-in.report-print-failed": "Registra problema di stampa",
    "check-in.report-print-success": "Stampa riuscita",
    "check-in.scan": "Scansiona codice",
    "check-in.scan-failed": "Impossibile scansionare il codice di iscrizione.",
    "check-in.station-error": "Errore della postazione di check-in",
    "check-in.station-identifier": "Nome postazione",
    "check-in.station-title": "Postazione di check-in",
    "check-in.token-required": "Il token del codice di iscrizione è obbligatorio.",
    "check-in.token-url-invalid": "L'URL scansionato non contiene un token del codice di iscrizione.",
    "checked-in": "Check-in effettuato",
    "city": "Città",
    "clear": "Cancella",
    "clear-filters": "Azzera filtri",
    "clear-search": "Cancella ricerca",
    "clipboard-unavailable": "Gli appunti non sono disponibili",
    "code-required": "Il codice è obbligatorio.",
    "combined-program-layout-pdf-url": "File PDF di programma e planimetria",
    "company-payee-name": "Nome azienda/beneficiario",
    "condition": "Condizione",
    "condition-type": "Tipo di condizione",
    "config.accommodation": "Impostazioni alloggio",
    "config.email-templates": "Modelli email",
    "config.languages": "Lingue",
    "config.options": "Opzioni di iscrizione",
    "config.pricing": "Prezzi",
    "config.tax": "Impostazioni fiscali",
    "config.tax-description": "Questi valori fiscali alimentano le offerte di quota e alloggio. Mantienili allineati alle reali regole di fatturazione dell'evento.",
    "configuration-fallback": "Predefinito",
    "confirm": "Conferma",
    "confirm-new-password": "Conferma nuova password",
    "confirm-new-password-required": "Conferma la nuova password.",
    "country": "Paese",
    "created-timeline": "Creato: {{value}}",
    "cta.clone": "Clona",
    "cta.copied": "Copiato",
    "cta.copy": "Copia",
    "cta.create-event": "Crea evento",
    "cta.manage-hotels-and-room-types": "Gestisci hotel e tipologie di camera",
    "currency": "Valuta",
    "customer-purchase-order": "Ordine d'acquisto del cliente",
    "customer-purchase-order-download-failed": "Impossibile scaricare l'ordine d'acquisto del cliente.",
    "customer-purchase-order-missing": "Mancante",
    "customer-purchase-order-upload-failed": "Impossibile salvare l'ordine d'acquisto del cliente.",
    "customer-purchase-order-upload-success": "Ordine d'acquisto del cliente salvato.",
    "date-range": "Periodo",
    "dates": "Date",
    "deactivate": "Disattiva",
    "delete-confirmation-count-target": "Record selezionati da eliminare ({{itemType}}): {{count}}.",
    "delete-confirmation-named-target": "{{itemType}} \"{{itemName}}\" verrà eliminato.",
    "delete-confirmation-question": "Vuoi davvero eliminarlo?",
    "delete-confirmation-target": "{{itemType}} verrà eliminato.",
    "delete-confirmation-title": "Conferma eliminazione",
    "delete-target-accommodation-option": "opzione di alloggio",
    "delete-target-event-access": "accesso all'evento",
    "delete-target-file": "file",
    "delete-target-hotel": "hotel",
    "delete-target-invitation": "invito in sospeso",
    "delete-target-participant": "partecipante",
    "delete-target-payer": "pagante",
    "delete-target-record": "record",
    "delete-target-template-field": "campo del modello",
    "delivery-note": "Nota di consegna",
    "delivery-timeline": "Cronologia di consegna",
    "departure": "Partenza",
    "depends-on-code": "Dipende dal codice",
    "depends-on-value": "Dipende dal valore",
    "description-en": "Descrizione (inglese)",
    "description-hr": "Descrizione (croato)",
    "description-required": "La descrizione è obbligatoria.",
    "developer-feedback-description": "Descrizione del problema",
    "developer-feedback-error": "Al momento non è possibile inviare la segnalazione. Riprova.",
    "developer-feedback-help": "Descrivi cosa è successo. Il tuo nome e la tua email verranno inviati al team di sviluppo.",
    "developer-feedback-placeholder": "Cosa stavi cercando di fare e cosa è successo?",
    "developer-feedback-queued": "La segnalazione è stata ricevuta ed è in attesa di invio.",
    "developer-feedback-send": "Invia segnalazione",
    "developer-feedback-title": "Segnala un problema",
    "document-ready": "Disponibile",
    "document-unavailable": "Non disponibile",
    "download": "Scarica",
    "download-certificate": "Scarica attestato",
    "download-customer-purchase-order": "Scarica ordine d'acquisto",
    "download-offer": "Scarica offerta",
    "download-rooming-csv": "Scarica CSV rooming",
    "due-date": "Scadenza",
    "edit-organization-member": "Modifica membro",
    "eligibility-actions": "Azioni di idoneità",
    "email-channel-active": "Email attiva",
    "email-delivery": "Consegna email",
    "email-delivery-history": "Storico consegne email",
    "email-delivery-history-error-title": "Lo storico delle consegne non è disponibile",
    "email-delivery-history-helper": "Usa l'email per le notifiche dell'evento. La consegna tramite app e push non è attiva in questa web app.",
    "email-delivery-ok": "Nessun errore di consegna registrato.",
    "email-delivery-queued": "In coda",
    "email-notifications": "Notifiche email",
    "email-recipient": "Destinatario email",
    "email-signature": "Firma email",
    "email-template-footer": "Piè di pagina",
    "email-template-header": "Intestazione",
    "email-unverified": "Non verificato",
    "email-verification": "Verifica email",
    "email-verified": "Verificato",
    "emailed": "Inviato via email",
    "end-date-required": "La data di fine è obbligatoria.",
    "entity": "Entità",
    "enums:ACCOMMODATION": "Alloggio",
    "enums:ACTIVE": "Attivo",
    "enums:ADD_LINE_ITEM": "Aggiungi voce",
    "enums:ADMINISTRATOR": "Amministratore",
    "enums:ALWAYS": "Sempre",
    "enums:ARCHIVED": "Archiviato",
    "enums:BANK_TRANSFER": "Bonifico bancario",
    "enums:CARD": "Carta",
    "enums:CASH": "Contanti",
    "enums:CATEGORY_ONLY": "Solo categoria",
    "enums:NO_CHARGE": "Gratuito",
    "enums:CHECKBOX": "Casella di controllo",
    "enums:COMPANY": "Azienda",
    "enums:DATE": "Data",
    "enums:DEPENDS_ON_ANSWER": "Dipende dalla risposta",
    "enums:DRAFT": "Bozza",
    "enums:EMAIL": "Email",
    "enums:EMAILED": "Inviato via email",
    "enums:EN": "Inglese",
    "enums:EXPIRED": "Scaduto",
    "enums:FAILED": "Non riuscito",
    "enums:GENERATED": "Generato",
    "enums:HR": "Croato",
    "enums:INDIVIDUAL": "Persona fisica",
    "enums:MANUALLY_RECONCILED": "Riconciliato manualmente",
    "enums:MULTI_CHOICE": "Scelta multipla",
    "enums:MULTI_SELECT": "Selezione multipla",
    "enums:NUMBER": "Numero",
    "enums:PAID": "Pagato",
    "enums:PARTICIPATION": "Quota di partecipazione",
    "enums:PENDING": "In attesa",
    "enums:PHONE": "Telefono",
    "enums:POS": "POS",
    "enums:PPO": "PPO",
    "enums:REFUNDED": "Rimborsato",
    "enums:RELEASED": "Rilasciato",
    "enums:REPLACED": "Sostituito",
    "enums:RESERVED": "Prenotato",
    "enums:SELECT": "Selezione",
    "enums:SINGLE_CHOICE": "Scelta singola",
    "enums:SPONSOR": "Sponsor",
    "enums:STANDARD_VAT": "IVA standard",
    "enums:TEXT": "Testo",
    "enums:TEXT_AREA": "Testo su più righe",
    "enums:UNPAID": "Non pagato",
    "enums:USER": "Utente",
    "enums:YES_NO": "Sì / No",
    "error": "Errore",
    "error-deleting-item": "Impossibile eliminare l'elemento",
    "error.download-failed": "Download non riuscito",
    "error.upload-failed": "Caricamento non riuscito",
    "errors.unknown": "Errore sconosciuto",
    "event-access-card-title": "Accesso all'evento",
    "event-access-empty": "Nessun collaboratore",
    "event-access-grant": "Concedi accesso",
    "event-access-granted": "Accesso all'evento concesso",
    "event-access-revoke": "Revoca",
    "event-access-revoked": "Accesso all'evento revocato",
    "event-access-user-placeholder": "Organizzatore",
    "event-audit.action": "Azione",
    "event-audit.action.archived": "Archiviato",
    "event-audit.action.created": "Creato",
    "event-audit.action.deleted": "Eliminato",
    "event-audit.action.restored": "Ripristinato",
    "event-audit.action.updated": "Modificato",
    "event-audit.details": "Dettagli",
    "event-audit.empty": "Nessuna modifica registrata per questo evento.",
    "event-audit.entity": "Entità / ID",
    "event-audit.event-archived-details-prefix": "Evento archiviato",
    "event-audit.load-error": "Impossibile caricare l'audit",
    "event-audit.load-error-description": "Aggiorna la pagina o riprova più tardi.",
    "event-audit.time": "Ora",
    "event-audit.user": "Utente",
    "event-basic-setup": "Impostazioni di base dell'evento",
    "event-basic-setup-guided": "Dati di base e testo pubblico",
    "event-basic-setup-saved": "Impostazioni dell'evento salvate",
    "event-config-accommodation-hotel-required": "Seleziona un hotel dal catalogo o aggiungi prima un nuovo hotel.",
    "event-config-accommodation-hotel-select": "Hotel dal catalogo globale",
    "event-config-accommodation-hotel-select-placeholder": "Scegli un hotel dal catalogo",
    "event-config-accommodation-new-hotel": "Nuovo hotel nel catalogo",
    "event-config-accommodation-new-hotel-placeholder": "Inserisci il nome dell'hotel se manca",
    "event-config-accommodation-option-saved": "Opzione di alloggio salvata",
    "event-config-accommodation-options": "Opzioni di alloggio",
    "event-config-accommodation-options-deleted": "Opzioni di alloggio eliminate",
    "event-config-accommodation-options-description": "Definisci hotel, tipologia di camera, prezzo, disponibilità prenotabile, periodo di soggiorno e scadenza di pagamento in un'unica riga. Gli hotel provengono dal catalogo globale; se un hotel manca, aggiungilo qui e verrà memorizzato per gli eventi futuri.",
    "event-config-accommodation-options-empty": "Nessuna opzione di alloggio.",
    "event-config-accommodation-period-missing": "Periodo mancante",
    "event-config-accommodation-price-invalid": "Il prezzo deve essere zero o superiore.",
    "event-config-add-accommodation-option": "Aggiungi opzione di alloggio",
    "event-config-add-fee-row": "Aggiungi riga di prezzo",
    "event-config-add-hotel-to-catalog": "Aggiungi hotel al catalogo",
    "event-config-add-room-inventory": "Aggiungi disponibilità camere",
    "event-config-add-room-type": "Aggiungi tipologia di camera",
    "event-config-delete-accommodation-option-title": "Eliminare l'opzione di alloggio?",
    "event-config-delete-accommodation-options-confirm": "Eliminare davvero le opzioni di alloggio selezionate?",
    "event-config-delete-accommodation-options-reservations-confirm": "Alle seguenti opzioni di alloggio sono collegate prenotazioni: {{options}}. Eliminando le opzioni verranno rimosse anche queste prenotazioni. Eliminarle davvero?",
    "event-config-delete-accommodation-options-reservations-warning": "Alle seguenti opzioni di alloggio sono collegate prenotazioni: {{options}}. Eliminando le opzioni verranno rimosse anche queste prenotazioni.",
    "event-config-delete-accommodation-options-title": "Eliminare le opzioni di alloggio?",
    "event-config-edit-accommodation-option": "Modifica opzione di alloggio",
    "event-config-event-hotels": "Hotel usati in questo evento",
    "event-config-fee-price-prerequisite-description": "Aggiungi {{items}} prima di aggiungere righe di prezzo.",
    "event-config-fee-price-requires-period": "almeno un periodo di prezzo",
    "event-config-fee-price-requires-type": "almeno un tipo di quota partecipante",
    "event-config-fee-prices-guided": "Righe di prezzo",
    "event-config-fee-prices-prerequisite-title": "Completa la configurazione delle quote prima di aggiungere righe di prezzo.",
    "event-config-fee-types-guided": "Tipi di quota partecipante",
    "event-config-guided-accommodation": "Impostazioni alloggio",
    "event-config-hotel-catalog-choice": "catalogo",
    "event-config-hotel-create-empty-response": "L'hotel non è stato restituito dopo il salvataggio.",
    "event-config-hotel-link-empty-response": "L'hotel non è stato restituito dopo il collegamento.",
    "event-config-hotel-name-required": "Il nome dell'hotel è obbligatorio.",
    "event-config-hotel-saved": "Hotel salvato",
    "event-config-hotel-unavailable": "Hotel non disponibile",
    "event-config-hotels-empty-description": "Collega un hotel esistente o aggiungi il nome di un nuovo hotel prima di definire le tipologie di camera.",
    "event-config-hotels-empty-title": "Nessun hotel collegato",
    "event-config-link-hotel-action": "Collega hotel",
    "event-config-link-hotel-empty": "Non sono ancora disponibili hotel riutilizzabili.",
    "event-config-link-hotel-help": "Scegli un hotel riutilizzabile dal catalogo condiviso per collegarlo a questo evento.",
    "event-config-link-hotel-label": "Collega un hotel già usato in un altro evento",
    "event-config-new-accommodation-option": "Nuova opzione di alloggio",
    "event-config-new-hotel-action": "Aggiungi hotel",
    "event-config-new-hotel-label": "Aggiungi il nome di un nuovo hotel a questo evento",
    "event-config-new-hotel-placeholder": "Nome dell'hotel o della struttura",
    "event-config-operator-tax": "Imposta su quota e alloggio",
    "event-config-participant-emails": "Email ai partecipanti",
    "event-config-room-allotment-prerequisite-description": "Collega o aggiungi {{items}} prima di aggiungere la disponibilità camere.",
    "event-config-room-allotment-requires-hotel": "un hotel",
    "event-config-room-allotment-requires-room-type": "una tipologia di camera",
    "event-config-room-allotments-prerequisite-title": "Completa hotel e tipologie di camera prima di aggiungere la disponibilità camere.",
    "event-config-room-capacity-invalid": "La capacità della camera deve essere un numero intero maggiore di zero.",
    "event-config-room-inventory": "Disponibilità camere e scadenze di pagamento",
    "event-config-room-type-empty-response": "La tipologia di camera non è stata restituita dopo il salvataggio.",
    "event-config-room-type-name-placeholder": "Nome della tipologia di camera",
    "event-config-room-type-name-required": "Il nome della tipologia di camera è obbligatorio.",
    "event-config-room-type-prerequisite-description": "Collega o aggiungi {{items}} prima di aggiungere tipologie di camera.",
    "event-config-room-type-requires-hotel": "un hotel",
    "event-config-room-type-unavailable": "Tipologia di camera non disponibile",
    "event-config-room-types-prerequisite-title": "Collega un hotel prima di aggiungere tipologie di camera.",
    "event-config-room-types-setup": "Tipologie di camera prenotabili",
    "event-config-save-accommodation-option": "Salva opzione di alloggio",
    "event-config-save-hotel": "Salva hotel",
    "event-config-total-rooms-invalid": "Il numero totale di camere deve essere un numero intero maggiore di zero.",
    "event-create-wizard.address": "Indirizzo della sede",
    "event-create-wizard.basic-description": "Crea ora la struttura dell'evento. Completa testi pubblici, grafiche, prezzi, alloggio e attività dall'area di lavoro.",
    "event-create-wizard.create-and-open": "Crea evento",
    "event-create-wizard.created": "Evento creato",
    "event-create-wizard.end-date-after-start": "La data di fine deve essere uguale o successiva alla data di inizio.",
    "event-create-wizard.event-name": "Nome dell'evento",
    "event-create-wizard.fee-choice": "Quota di iscrizione",
    "event-create-wizard.fee-description": "Quota selezionata. Aggiungi periodi, tipi di partecipante e prezzi dopo la creazione.",
    "event-create-wizard.fee-no": "Nessuna quota",
    "event-create-wizard.fee-yes": "Evento a pagamento",
    "event-create-wizard.missing-event-id": "L'evento è stato creato, ma non è stato possibile identificare la nuova area di lavoro.",
    "event-create-wizard.no-fee-description": "Nessuna quota selezionata. Per il primo salvataggio non serve una matrice di prezzi.",
    "event-create-wizard.place": "Città / località",
    "event-create-wizard.title": "Nuovo evento",
    "event-end-date-before-start": "La data di fine deve essere uguale o successiva alla data di inizio.",
    "event-hotel-created": "Hotel aggiunto a questo evento",
    "event-hotel-linked": "Hotel collegato",
    "event-hotel-name-required": "Il nome dell'hotel è obbligatorio.",
    "event-information-en-required": "Le informazioni sull'evento in inglese sono obbligatorie.",
    "event-information-hr-required": "Le informazioni sull'evento in croato sono obbligatorie.",
    "event-lifecycle-status:ACTIVE": "Attivo",
    "event-lifecycle-status:COMPLETED": "Concluso",
    "event-operational-status.active": "Attivo",
    "event-operational-status.active.hint": "Pronto per le operazioni dell'evento.",
    "event-operational-status.completed": "Concluso",
    "event-operational-status.completed.hint": "Storico e attestati restano disponibili.",
    "event-operational-status.draft": "Configurazione in bozza",
    "event-operational-status.draft.hint": "Completa la configurazione prima di condividere l'iscrizione.",
    "event-operations-cockpit": "Panoramica operativa dell'evento",
    "event-option-is-charged": "L'attività è a pagamento?",
    "event-overview.accommodation-reservations": "Prenotazioni alloggio",
    "event-overview.active-codes-helper": "{{count}} codici QR attivi",
    "event-overview.active-form": "Link di iscrizione pronto",
    "event-overview.basics-missing": "Completa l'identità di base dell'evento prima che il team si affidi a questa area di lavoro.",
    "event-overview.basics-ready": "Nome, date e dettagli dell'evento sono pronti.",
    "event-overview.certificate-eligible-count": "{{count}} partecipanti registrati",
    "event-overview.certificate-follow-up-description": "Il dettaglio del partecipante contiene lo stato dell'invito QR, l'idoneità al check-in e le azioni sugli attestati.",
    "event-overview.certificate-follow-up-title": "Verifica QR e disponibilità degli attestati",
    "event-overview.certificate-helper": "Emissione e download dal dettaglio del partecipante",
    "event-overview.certificates-description": "I partecipanti registrati diventano idonei all'attestato dopo la conclusione dell'evento.",
    "event-overview.certificates-ready-sent": "Attestati pronti/inviati",
    "event-overview.check-before-sharing": "Verifica",
    "event-overview.check-in": "Check-in e QR",
    "event-overview.check-in-description": "Tieni visibili inviti QR e stato del check-in prima del giorno dell'evento.",
    "event-overview.checked-in-count": "{{count}} con check-in",
    "event-overview.fee-disabled": "Disattivato",
    "event-overview.form-follow-up-description": "Il link di iscrizione ospitato usa la configurazione attuale dell'evento e va verificato prima che ATI lo condivida.",
    "event-overview.form-follow-up-title": "Verifica la condivisione dell'iscrizione",
    "event-overview.form-needed": "Verifica il link di iscrizione prima di condividerlo.",
    "event-overview.form-needed-badge": "Verifica link di iscrizione",
    "event-overview.guided-setup": "Configurazione guidata dell'evento",
    "event-overview.guided-setup-description": "Completa la configurazione minima nell'ordine previsto prima di aprire le iscrizioni.",
    "event-overview.invited-count": "{{count}} invitati",
    "event-overview.next-actions": "Prossime azioni",
    "event-overview.next-actions-ready": "Nessun blocco immediato",
    "event-overview.next-actions-ready-description": "L'area di lavoro è allineata. Usa partecipanti, rooming e notifiche per le operazioni in corso.",
    "event-overview.notifications-description": "Controlla lo storico delle email e mantieni il follow-up legato a questo evento.",
    "event-overview.notifications-helper": "Solo consegna email nella v0.1",
    "event-overview.open-accommodation": "Apri alloggio",
    "event-overview.open-certificates": "Apri dettaglio partecipante",
    "event-overview.open-check-in": "Apri azioni partecipante",
    "event-overview.open-event-basics": "Apri dati di base",
    "event-overview.open-notifications": "Apri notifiche",
    "event-overview.open-participants": "Apri partecipanti",
    "event-overview.open-registration-form": "Apri modulo di iscrizione",
    "event-overview.open-rooming": "Apri rooming",
    "event-overview.open-settings": "Apri impostazioni",
    "event-overview.paid-fees": "Quote pagate",
    "event-overview.participant-count": "{{count}} partecipanti",
    "event-overview.participants-description": "Segui stato dell'iscrizione, stato dei pagamenti di quota e alloggio, offerte, inviti QR e attestati da un unico elenco.",
    "event-overview.payment-follow-up-description": "Controlla i pagamenti non pagati o in attesa dalla panoramica partecipanti.",
    "event-overview.payment-follow-up-title": "Risolvi i pagamenti in sospeso",
    "event-overview.payments": "Pagamenti",
    "event-overview.payments-description": "Controlla lo stato dei pagamenti dei partecipanti e il follow-up delle offerte.",
    "event-overview.payments-follow-up": "{{count}} non pagati o in attesa",
    "event-overview.payments-helper": "{{count}} record non pagati o in attesa",
    "event-overview.public-registration": "Iscrizione pubblica",
    "event-overview.quick-totals": "Riepilogo evento",
    "event-overview.registration-count": "{{count}} iscrizioni",
    "event-overview.registration-form-inactive-helper": "Attiva il modulo di iscrizione di base prima di condividere il link ospitato.",
    "event-overview.registration-link-live-helper": "Il link di iscrizione ospitato è pronto. Prezzi, alloggio, attività e testi pubblici restano aggiornati dalla configurazione.",
    "event-overview.registration-missing-helper": "Salva nome, date e testo pubblico dell'evento prima di condividere il link di iscrizione ospitato.",
    "event-overview.registration-payment-helper": "Salva i metodi di pagamento della quota prima di condividere il link di iscrizione ospitato.",
    "event-overview.registration-ready-helper": "Il link di iscrizione ospitato è pronto. Le modifiche alla configurazione appaiono subito.",
    "event-overview.reservation-count": "{{count}} prenotazioni",
    "event-overview.review-payments": "Controlla i pagamenti dei partecipanti",
    "event-overview.room-allotments-missing": "Aggiungi almeno una disponibilità di camere affinché l'iscrizione pubblica abbia camere reali.",
    "event-overview.room-count": "{{count}} camere",
    "event-overview.rooming": "Rooming",
    "event-overview.rooming-description": "Gestisci la pressione sugli alloggi, camere prenotate, pernottamenti e rilasci.",
    "event-overview.rooming-follow-up-description": "Per questo evento mancano ancora hotel, tipologie di camera o disponibilità camere.",
    "event-overview.rooming-follow-up-title": "Completa la configurazione del rooming",
    "event-overview.rooming-helper": "{{count}} prenotazioni",
    "event-overview.rooming-optional": "Facoltativo se l'evento non offre alloggio.",
    "event-overview.rooming-setup": "Configurazione rooming",
    "event-overview.rooming-setup-summary": "{{hotels}} hotel · {{roomTypes}} tipologie di camera · {{allotments}} disponibilità",
    "event-overview.settings-follow-up-description": "Conferma i dati di base dell'evento affinché il team veda sempre il contesto corretto.",
    "event-overview.settings-follow-up-title": "Completa l'identità dell'evento",
    "event-overview.setup-accommodation-description": "Hotel, tipologie di camera, disponibilità, prezzi dell'alloggio e scadenze di pagamento.",
    "event-overview.setup-activities-description": "Attività e servizi aggiuntivi, a pagamento o gratuiti, mostrati nell'iscrizione.",
    "event-overview.setup-activities-optional": "Facoltativo se l'evento non prevede attività o servizi aggiuntivi selezionabili.",
    "event-overview.setup-activities-ready": "{{count}} attività o servizi aggiuntivi attivi sono pronti per l'iscrizione.",
    "event-overview.setup-pipeline": "Verifica della configurazione",
    "event-overview.setup-pipeline-description": "Verifica la sequenza di configurazione: dati di base, quote/pagamento, alloggio, attività/servizi aggiuntivi e modulo di iscrizione.",
    "event-overview.setup-pricing-description": "Periodi di quota, prezzi per partecipante e stato attuale delle quote.",
    "event-overview.setup-pricing-fee-off": "La quota di partecipazione è disattivata per questo evento. Riapri questo passaggio solo se l'evento deve riscuotere quote.",
    "event-overview.setup-pricing-fee-on": "Questo evento prevede una quota di partecipazione. Salva i prezzi attuali prima di aprire le iscrizioni.",
    "event-overview.setup-registration-description": "Condividi il modulo ospitato, visualizza l'esperienza reale e copia il link pubblico o l'iframe da un unico punto.",
    "event-overview.setup-settings-description": "Nome, date, località, indirizzo, testi pubblici in croato e inglese, grafiche, impostazioni di base dell'attestato, email predefinite, metodi di pagamento e indicazione della quota di partecipazione.",
    "event-overview.setup-settings-missing": "Salva i dati di base dell'evento prima di passare ai prezzi e condividere il link di iscrizione ospitato.",
    "event-overview.setup-settings-ready": "I dati di base dell'evento sono salvati. Usa questa sezione quando grafiche, posizionamento sull'attestato o testi pubblici devono essere aggiornati.",
    "event-overview.signals-unavailable": "Indicatori dell'evento non disponibili",
    "event-overview.total-applications": "Iscrizioni totali",
    "event-overview.trend-chart-aria": "Andamento di iscrizioni e prenotazioni",
    "event-overview.trend-days": "Giorni",
    "event-overview.trend-group-by": "Raggruppa per",
    "event-overview.trend-last-30-days": "Ultimi 30 giorni",
    "event-overview.trend-last-6-months": "Ultimi 6 mesi",
    "event-overview.trend-last-7-days": "Ultimi 7 giorni",
    "event-overview.trend-months": "Mesi",
    "event-overview.trend-period": "Periodo",
    "event-overview.trend-registrations": "Iscrizioni",
    "event-overview.trend-reservations": "Prenotazioni",
    "event-overview.trend-title": "Stato dell'evento",
    "event-overview.trend-weeks": "Settimane",
    "event-payment-method-required": "Attiva almeno un metodo di pagamento per ogni categoria.",
    "event-payment-methods-saved": "Metodi di pagamento salvati",
    "event-payment-methods-unsaved-defaults-description": "Gli interruttori qui sotto mostrano le impostazioni consigliate per bonifico/carta. Le categorie mancanti non sono disponibili nel modulo pubblico finché non salvi i metodi di pagamento.",
    "event-payment-methods-unsaved-defaults-title": "I metodi di pagamento predefiniti non sono ancora salvati",
    "event-required": "Seleziona un evento",
    "event-tax-settings-saved": "Impostazioni fiscali salvate",
    "event-workspace.accommodation": "Alloggio",
    "event-workspace.active-group": "Attivo",
    "event-workspace.activities": "Attività",
    "event-workspace.badge-template": "Accrediti",
    "event-workspace.certificate-template": "Attestati",
    "event-workspace.check-in": "Check-in",
    "event-workspace.current-group": "Gruppo corrente",
    "event-workspace.current-section": "Sezione corrente",
    "event-workspace.current-workflow": "Flusso di lavoro corrente",
    "event-workspace.form-linked": "Modulo collegato",
    "event-workspace.form-needed": "Modulo necessario",
    "event-workspace.group-operate": "Operatività",
    "event-workspace.group-selector": "Area dell'area di lavoro dell'evento",
    "event-workspace.group-setup": "Configurazione",
    "event-workspace.group.operations": "Operatività",
    "event-workspace.group.setup": "Configurazione",
    "event-workspace.invalid-event": "Evento non valido",
    "event-workspace.load-error": "Area di lavoro dell'evento non disponibile",
    "event-workspace.navigation": "Navigazione dell'area di lavoro dell'evento",
    "event-workspace.not-found": "Evento non trovato.",
    "event-workspace.open": "Apri",
    "event-workspace.overview": "Panoramica",
    "event-workspace.registration-fees": "Quote e pagamento",
    "event-workspace.registration-form": "Modulo",
    "event-workspace.rooming": "Prenotazioni",
    "event-workspace.section-selector": "Sezione dell'area di lavoro dell'evento",
    "event-workspace.settings": "Dati di base",
    "event-workspace.setup": "Configurazione",
    "event-workspace.status-labels": "Etichette di stato dell'evento",
    "event-workspace.workspace": "Area di lavoro dell'evento",
    "events-page.activate-confirm-description": "L'evento diventa operativo. L'iscrizione pubblica richiede comunque un modulo di iscrizione attivo.",
    "events-page.activate-confirm-title": "Contrassegnare questo evento come attivo?",
    "events-page.activated": "Evento contrassegnato come attivo",
    "events-page.active-count": "{{count}} eventi",
    "events-page.active-error": "Eventi non disponibili",
    "events-page.active-error-description": "Aggiorna l'elenco o riprova più tardi.",
    "events-page.active-title": "Eventi disponibili per la selezione",
    "events-page.archive-action": "Archivia evento",
    "events-page.archive-confirm-description": "Questo evento esce dalla selezione attiva e resta disponibile in archivio e nello storico.",
    "events-page.archive-confirm-title": "Archiviare questo evento?",
    "events-page.archive-error": "Archivio non disponibile",
    "events-page.archive-error-description": "Aggiorna l'archivio o riprova più tardi.",
    "events-page.archive-title": "Archivio",
    "events-page.archived": "Evento archiviato",
    "events-page.choose-event": "Scegli prima l'evento",
    "events-page.choose-event-help": "Configurazione, partecipanti, rooming e notifiche si aprono nell'area di lavoro dell'evento selezionato.",
    "events-page.complete-confirm-description": "L'evento resta disponibile qui e la generazione degli attestati diventa disponibile per le operazioni concluse.",
    "events-page.complete-confirm-title": "Contrassegnare questo evento come concluso?",
    "events-page.completed": "Evento contrassegnato come concluso",
    "events-page.completed-ready": "Pronto per gli attestati",
    "events-page.duplicate": "Duplica",
    "events-page.duplicate-missing-event-id": "L'evento duplicato è stato creato, ma non è stato possibile aprire la nuova area di lavoro.",
    "events-page.duplicated": "Evento duplicato",
    "events-page.empty-active": "Nessun evento ancora pronto per la selezione.",
    "events-page.empty-archive": "Nessun evento archiviato.",
    "events-page.mark-active": "Contrassegna come attivo",
    "events-page.mark-complete": "Contrassegna come concluso",
    "events-page.no-search-results": "Nessun evento corrisponde alla ricerca.",
    "events-page.reactivate": "Riattiva",
    "events-page.reactivate-confirm-description": "L'evento torna operativo e l'iscrizione pubblica può tornare disponibile.",
    "events-page.reactivate-confirm-title": "Riattivare questo evento?",
    "events-page.reactivated": "Evento tornato attivo",
    "events-page.restore": "Ripristina",
    "events-page.restored": "Evento ripristinato",
    "events-page.search-placeholder": "Cerca eventi",
    "export": "Esporta",
    "exported-by": "Esportato da",
    "failed-timeline": "Non riuscito: {{value}}",
    "fee": "Quota",
    "fee-payment": "Pagamento della quota",
    "fee-prices": "Prezzi delle quote",
    "fee-prices-helper": "I prezzi delle quote collegano i tipi di quota ai periodi early, regular e late.",
    "fee-type": "Tipo di quota",
    "fee-type-public-hidden": "Nascosto nel modulo pubblico",
    "fee-type-requires-proof": "Richiede documentazione",
    "fee-types": "Tipi di quota",
    "feeTypeId": "Tipo di quota",
    "file": "File",
    "file-not-selected": "Nessun file selezionato",
    "file-uploaded": "File caricato",
    "first-name": "Nome",
    "forgot-password": "Password dimenticata?",
    "form.error": "Errore",
    "free": "Gratuito",
    "full-name": "Nome",
    "general-settings-saved": "Impostazioni generali salvate",
    "generate": "Genera",
    "generate-certificate": "Genera attestato",
    "generated": "Generato",
    "global-settings": "Impostazioni globali",
    "gross": "Lordo",
    "gross-total": "Totale lordo",
    "history": "Storico",
    "hotel": "Hotel",
    "hotel-name": "Nome dell'hotel",
    "hotel-unavailable": "Hotel non disponibile",
    "hotels": "Hotel",
    "hotels-cancel": "Annulla",
    "hotels-category-not-selected": "Non selezionata",
    "hotels-category-select": "Seleziona la categoria dell'hotel",
    "hotels-category-stars": "Categoria dell'hotel: {{count}} stelle su 5",
    "hotels-delete": "Elimina",
    "hotels-delete-confirm": "Eliminare questo hotel dal catalogo globale?",
    "hotels-delete-failed": "Impossibile eliminare l'hotel.",
    "hotels-deleted": "Hotel eliminato.",
    "hotels-description": "Catalogo globale degli hotel",
    "hotels-field-address": "Indirizzo",
    "hotels-field-category": "Categoria",
    "hotels-field-city": "Città",
    "hotels-field-country": "Paese",
    "hotels-field-name": "Nome",
    "hotels-field-notes": "Note",
    "hotels-in-use": "Questo hotel è collegato a un evento e non può essere eliminato. Rimuovi prima i collegamenti nelle impostazioni dell'evento.",
    "hotels-name-required": "Inserisci il nome dell'hotel.",
    "hotels-new": "Nuovo hotel",
    "hotels-not-found": "Hotel non trovato.",
    "hotels-retry": "Riprova",
    "hotels-save": "Salva",
    "hotels-save-failed": "Impossibile salvare l'hotel.",
    "hotels-saved": "Hotel salvato.",
    "hotels-search": "Cerca per nome, città o paese",
    "hotels-shared-info": "Le modifiche ai dati dell'hotel valgono per tutti gli eventi che lo usano.",
    "iban": "IBAN",
    "inactive": "Inattivo",
    "institution-company": "Istituzione/Azienda",
    "invitation-check-in": "Inviti e check-in",
    "invitation-check-in-summary-unavailable": "Riepilogo di inviti e check-in non disponibile",
    "invited": "Invitato",
    "issued": "Emesso",
    "label-en": "Etichetta (inglese)",
    "label-hr": "Etichetta (croato)",
    "labelEn": "Etichetta (inglese)",
    "labelHr": "Etichetta (croato)",
    "language": "Lingua",
    "last-name": "Cognome",
    "lifecycle-status": "Stato del ciclo di vita",
    "list-search": "Ricerca nell'elenco",
    "logo": "Logo",
    "mail-first-template-helper": "Email come canale principale",
    "manual": "Manuale",
    "manual-reconcile-failed": "Impossibile contrassegnare il pagamento come riconciliato.",
    "manual-reconcile-note-prompt": "Inserisci una nota di riconciliazione.",
    "manual-reconcile-note-required": "La nota di riconciliazione è obbligatoria.",
    "manual-reconcile-success": "Pagamento contrassegnato come riconciliato.",
    "manual-reconciliation-note": "Nota di riconciliazione manuale",
    "mark-reconciled": "Contrassegna come riconciliato",
    "missing": "Mancante",
    "more-lines": "voci aggiuntive",
    "name-en-required": "Il nome in inglese è obbligatorio.",
    "name-hr-required": "Il nome in croato è obbligatorio.",
    "name-required": "Il nome è obbligatorio.",
    "net": "Netto",
    "new-password": "Nuova password",
    "new-password-min-length": "Usa almeno {{count}} caratteri.",
    "new-password-required": "La nuova password è obbligatoria.",
    "new-payer": "Nuovo pagante",
    "nights": "notti",
    "no-accommodation-offer": "Nessuna",
    "no-certificates": "Nessun attestato",
    "no-company": "Nessuna azienda",
    "no-event-selected": "Nessun evento selezionato.",
    "no-fee-offer": "Nessuna",
    "no-filter-options": "Nessuna opzione",
    "no-offer": "Nessuna",
    "no-payment-allocations": "Nessuna allocazione di pagamento",
    "no-registration": "Nessuna",
    "no-registration-codes": "Nessun codice di iscrizione",
    "no-reservation": "Nessuna",
    "no-rooming-registrations-found": "Nessuna prenotazione di alloggio trovata per questo evento.",
    "no-stored-offers": "Nessuna offerta salvata",
    "no-subject": "Nessun oggetto",
    "not-authorized": "Non autorizzato",
    "not-available": "Non disponibile",
    "not-eligible": "Non pronto",
    "not-verified": "Non verificato",
    "notification-channel": "Canale di notifica",
    "notification-channel-application": "Applicazione",
    "notification-channel-email": "Email",
    "notification-channel-unknown": "Canale non registrato",
    "notification-delivery-failed-generic": "Consegna della notifica non riuscita.",
    "notification-delivery-multiple-failures": "{{count}} consegne non riuscite. Apri i destinatari per i dettagli.",
    "notification-delivery-ok": "Nessun errore di consegna registrato.",
    "notification-no-message-preview": "Nessun contenuto registrato",
    "notification-recipient": "Destinatario",
    "notification-without-template": "Senza modello",
    "notifications-add-filtered-recipients": "Aggiungi tutti i filtrati",
    "notifications-clear-recipients": "Annulla selezione",
    "notifications-compose-description": "Scegli un canale di notifica, usa facoltativamente un modello e invia un messaggio ai partecipanti selezionati.",
    "notifications-compose-title": "Invia notifica dell'evento",
    "notifications-draft-loaded-success": "Bozza caricata nel modulo.",
    "notifications-draft-missing-recipients-description": "I seguenti destinatari della bozza salvata non esistono più. Conferma per rimuoverli dalla selezione.",
    "notifications-draft-missing-recipients-title": "Alcuni destinatari non sono più disponibili",
    "notifications-draft-recipients-loading": "Attendi il caricamento dell'elenco dei destinatari.",
    "notifications-draft-recipients-unavailable": "La bozza non può essere caricata finché l'elenco dei destinatari non è disponibile.",
    "notifications-draft-save-failed": "Impossibile salvare la bozza della notifica.",
    "notifications-draft-save-success": "Bozza della notifica salvata.",
    "notifications-draft-save-success-count": "Bozza della notifica salvata per {{count}} destinatari.",
    "notifications-error": "Le notifiche non sono al momento disponibili.",
    "notifications-footer": "Piè di pagina",
    "notifications-footer-placeholder": "Seleziona un modello o inserisci il piè di pagina della notifica.",
    "notifications-header": "Intestazione",
    "notifications-header-placeholder": "Seleziona un modello o inserisci l'intestazione della notifica.",
    "notifications-load-draft": "Carica bozza",
    "notifications-message": "Messaggio",
    "notifications-message-placeholder": "Inserisci il messaggio da inviare agli utenti.",
    "notifications-no-participation-fee-type": "Nessun tipo di quota",
    "notifications-no-recipients": "Per questo evento non ci sono ancora partecipanti disponibili per le notifiche.",
    "notifications-no-templates": "Aggiungi un modello email dell'evento prima di inviare notifiche.",
    "notifications-open-recipient-picker": "Seleziona destinatari",
    "notifications-recipient-count": "{{count}} destinatari",
    "notifications-recipient-details-search": "Cerca destinatari",
    "notifications-recipient-details-search-count": "{{shown}} di {{total}} destinatari",
    "notifications-recipient-details-search-empty": "Nessun destinatario corrisponde alla ricerca.",
    "notifications-recipient-details-search-placeholder": "Cerca per email, stato o consegna",
    "notifications-recipient-filter-all-companies": "Tutte le aziende",
    "notifications-recipient-filter-all-fee-types": "Tutti i tipi di quota",
    "notifications-recipient-filter-all-statuses": "Tutti gli stati",
    "notifications-recipient-picker-count": "{{filtered}} visualizzati, {{selected}} selezionati",
    "notifications-recipient-picker-title": "Selezione destinatari",
    "notifications-recipient-registration-id": "Iscrizione {{id}}",
    "notifications-recipient-search": "Cerca destinatari",
    "notifications-recipient-search-placeholder": "Nome, email, azienda, telefono...",
    "notifications-recipients": "Destinatari",
    "notifications-recipients-button": "Destinatari",
    "notifications-recipients-error-title": "I destinatari non sono disponibili",
    "notifications-reply-to-addresses": "Indirizzi Reply-To",
    "notifications-reply-to-enabled": "Usa un indirizzo Reply-To",
    "notifications-reply-to-placeholder": "Inserisci gli indirizzi Reply-To",
    "notifications-retry-failed": "Riprova i non riusciti",
    "notifications-retry-queued-success": "Nuovo invio pianificato per {{count}} destinatari.",
    "notifications-save-draft": "Salva bozza",
    "notifications-save-recipient-selection": "Salva selezione",
    "notifications-select-all-recipients": "Seleziona tutti i destinatari",
    "notifications-select-channel": "Seleziona un canale di notifica",
    "notifications-select-recipients": "Seleziona i partecipanti per questa notifica",
    "notifications-select-template": "Seleziona un modello (facoltativo)",
    "notifications-selected-count": "Destinatari selezionati: {{selected}}",
    "notifications-send": "Invia notifica",
    "notifications-send-failed-count": "Nessuna notifica è stata messa in coda. {{failedCount}} non riuscite. Consulta lo storico per i dettagli.",
    "notifications-send-partial-count": "{{sentCount}} notifiche in coda. {{failedCount}} non è stato possibile metterle in coda. Consulta lo storico per i dettagli.",
    "notifications-send-queued-count": "{{count}} notifiche in coda.",
    "notifications-send-queued-partial-count": "{{queuedCount}} notifiche in coda. {{failedCount}} non è stato possibile metterle in coda. Consulta lo storico per i dettagli.",
    "notifications-send-success": "Notifiche in coda.",
    "notifications-send-success-count": "{{count}} notifiche in coda.",
    "notifications-template-subject-placeholder": "Inserisci l'oggetto della notifica.",
    "notifications-templates-error-title": "I modelli email non sono disponibili",
    "offer": "Offerta",
    "offer-document": "Documento dell'offerta",
    "offer-history": "Storico offerte",
    "offer-id": "ID offerta",
    "offer-number-value": "Offerta {{offerNumber}}",
    "offer-pdf": "PDF dell'offerta",
    "offer-resend-failed": "Impossibile inviare l'email dell'offerta",
    "offer-resend-queued": "Email dell'offerta in coda.",
    "offer-resend-success": "Email dell'offerta inviata",
    "offer-state": "Stato dell'offerta",
    "oib": "OIB",
    "ok": "OK",
    "on-site-flow-copy": "Istruzioni in loco e per il check-in",
    "on-site-registration-instructions-en-required": "Le istruzioni in loco in inglese sono obbligatorie.",
    "on-site-registration-instructions-hr-required": "Le istruzioni in loco in croato sono obbligatorie.",
    "onboarding-email-failed": "Non riuscito",
    "onboarding-email-resent": "Reinviato",
    "onboarding-email-sent": "Inviato",
    "open": "Apri",
    "open-cockpit": "Apri dettaglio",
    "open-color-picker": "Apri selettore colore",
    "open-participant-cockpit": "Apri dettaglio partecipante",
    "open-payer": "Apri pagante",
    "operational-status": "Stato operativo",
    "operational-status-before-archive": "Stato operativo prima dell'archiviazione",
    "operator-state": "Stato operativo",
    "organization-member-created-email-failed": "Membro dell'organizzazione creato, ma l'email di onboarding non è stata inviata. Controlla le impostazioni SMTP e invia di nuovo l'onboarding.",
    "organization-member-created-email-queued": "Membro dell'organizzazione creato; email di onboarding in coda.",
    "organization-member-deactivate-confirm": "Disattivare questo membro dell'organizzazione?",
    "organization-member-deactivated": "Membro dell'organizzazione disattivato",
    "organization-member-invite-removed": "Invito in sospeso rimosso",
    "organization-member-onboarding-email-failed": "Email di onboarding non riuscita. Controlla le impostazioni SMTP e invia di nuovo l'onboarding.",
    "organization-member-onboarding-help": "Scegli la tua password per confermare l'invito.",
    "organization-member-onboarding-invalid": "Questo link di onboarding non è valido o è scaduto.",
    "organization-member-onboarding-invalid-title": "Il link di onboarding non può essere usato",
    "organization-member-onboarding-queued": "Email di onboarding in coda.",
    "organization-member-onboarding-submit": "Imposta password",
    "organization-member-onboarding-title": "Configura l'account organizzatore",
    "organization-member-reactivate-confirm": "Riattivare questo membro dell'organizzazione?",
    "organization-member-reactivated": "Membro dell'organizzazione riattivato",
    "organization-member-remove-invite": "Rimuovi invito",
    "organization-member-updated": "Membro dell'organizzazione aggiornato",
    "organizer-email": "Email dell'organizzatore",
    "organizer-email-required": "L'email dell'organizzatore è obbligatoria.",
    "organizer-password-recovery": "Recupero password organizzatore",
    "organizer-password-recovery-help": "Usa l'indirizzo email da organizzatore per reimpostare la password. Gli amministratori non possono assegnare né vedere le password degli organizzatori.",
    "organizer-password-recovery-submit": "Invia istruzioni",
    "organizer-password-reset-complete-help": "Accedi con la tua nuova password da organizzatore.",
    "organizer-password-reset-help": "Inserisci una nuova password per il tuo account organizzatore.",
    "organizer-password-reset-invalid": "Questo link per reimpostare la password non è valido o è scaduto. Richiedi un nuovo link.",
    "organizer-password-reset-invalid-title": "Il link di reimpostazione non può essere usato",
    "organizer-password-reset-submit": "Imposta nuova password",
    "organizer-password-reset-title": "Scegli una nuova password",
    "organizerEmail": "Email dell'organizzatore",
    "organizerPhone": "Telefono dell'organizzatore",
    "participant-accommodation-empty": "Per questo evento non sono configurati periodi di alloggio.",
    "participant-accommodation-load-failed": "Impossibile caricare l'alloggio. Aggiorna la pagina e riprova.",
    "participant-actions": "Azioni sul partecipante",
    "participant-activities-empty": "Nessuna attività disponibile da mostrare.",
    "participant-activities-locked-after-offer": "Le attività si modificano prima della creazione dell'offerta di partecipazione.",
    "participant-activities-save-failed": "Impossibile salvare le attività del partecipante.",
    "participant-activities-save-success": "Attività del partecipante salvate.",
    "participant-and-event": "Partecipante / evento",
    "participant-basics-title": "Dati del partecipante",
    "participant-cockpit.actions-helper": "Offerte, pagamenti, QR e attestati",
    "participant-cockpit.subtitle": "Gestisci iscrizioni, pagamenti, offerte, QR e attestati da un unico elenco dell'evento.",
    "participant-delete-confirm": "Eliminare il partecipante?",
    "participant-delete-confirm-description": "Il partecipante {{participant}} verrà rimosso dall'evento.",
    "participant-delete-failed": "Impossibile eliminare il partecipante.",
    "participant-delete-success": "Partecipante eliminato.",
    "participant-detail": "Dettaglio partecipante",
    "participant-detail-partial-description": "I dati di base sono caricati, ma i dettagli operativi di iscrizioni, offerte e stato QR non sono al momento disponibili per questo record.",
    "participant-detail-partial-title": "Dati del partecipante parzialmente disponibili",
    "participant-detail.invalid": "Percorso del dettaglio partecipante non valido.",
    "participant-export-history": "Storico esportazioni CSV dei partecipanti",
    "participant-export-minimal-fields": "ID evento, email, stato, pagamento, attestato",
    "participant-name-unavailable": "Nome del partecipante non disponibile",
    "participant-note": "Nota",
    "participant-page-subtitle": "Dati del partecipante, pagante, alloggio e attività.",
    "participant-page-title": "Partecipante - {{participantFullName}}",
    "participant-register": "Iscrivi",
    "participant-register-active-form-required": "Prima di iscrivere un partecipante, crea e attiva un modulo di iscrizione pubblico nella scheda Modulo dell'evento.",
    "participant-register-already-exists": "Il partecipante è già iscritto a questo evento.",
    "participant-register-before-accommodation": "Iscrivi prima il partecipante per poter salvare l'alloggio nell'iscrizione.",
    "participant-register-before-activities": "Iscrivi prima il partecipante per poter salvare le attività nell'iscrizione.",
    "participant-register-failed": "Impossibile iscrivere il partecipante all'evento.",
    "participant-register-missing-company": "Istituzione / azienda",
    "participant-register-missing-email": "Email del partecipante",
    "participant-register-missing-first-name": "Nome del partecipante",
    "participant-register-missing-last-name": "Cognome del partecipante",
    "participant-register-missing-payer": "Pagante",
    "participant-register-missing-payer-address": "Indirizzo del pagante",
    "participant-register-missing-payer-city": "Città del pagante",
    "participant-register-missing-payer-contact": "Referente del pagante",
    "participant-register-missing-payer-country": "Paese del pagante",
    "participant-register-missing-payer-email": "Email del pagante",
    "participant-register-missing-payer-name": "Nome / persona del pagante",
    "participant-register-missing-payer-phone": "Telefono del pagante",
    "participant-register-missing-payer-tax-id": "OIB del pagante",
    "participant-register-missing-phone": "Telefono del partecipante",
    "participant-register-success": "Il partecipante è iscritto all'evento.",
    "participant-register-validation-title": "Completa i dati obbligatori prima dell'iscrizione.",
    "participant-registration-save-failed": "Impossibile salvare i dati dell'iscrizione.",
    "participant-registration-save-success": "Dati dell'iscrizione salvati.",
    "participant-rejection-failed": "Impossibile rifiutare l'iscrizione.",
    "participant-rejection-reason-prompt": "Inserisci il motivo del rifiuto di questa iscrizione.",
    "participant-rejection-reason-required": "Il motivo del rifiuto è obbligatorio.",
    "participant-rejection-success": "Iscrizione rifiutata.",
    "participant-room-reservation-missing-dates": "Inserisci le date di arrivo e partenza.",
    "participant-room-reservation-missing-room": "Seleziona un hotel e una tipologia di camera.",
    "participant-room-reservation-missing-room-count": "Inserisci il numero di camere.",
    "participant-room-reservation-save-failed": "Impossibile salvare la prenotazione dell'alloggio.",
    "participant-room-reservation-save-success": "Prenotazione dell'alloggio salvata.",
    "participant-save-failed": "Impossibile salvare i dati del partecipante.",
    "participant-save-success": "Dati del partecipante salvati.",
    "participant-search": "Cerca partecipanti",
    "participant-type-proof": "Documentazione del tipo di partecipante",
    "participants.bulk.certificates-helper": "{{count}} partecipanti selezionati. Gli attestati sono disponibili dal dettaglio del partecipante.",
    "participants.bulk.delete": "Elimina selezionati",
    "participants.bulk.delete-confirm": "Eliminare i partecipanti selezionati ({{count}})?",
    "participants.bulk.delete-failed-count": "Impossibile eliminare: {{count}} partecipanti.",
    "participants.bulk.deleted-count": "Eliminati: {{count}} partecipanti.",
    "participants.bulk.export-csv": "Esporta CSV",
    "participants.bulk.export-csv-error": "Esportazione CSV non riuscita. Riprova.",
    "participants.bulk.export-csv-success": "Esportazione CSV scaricata.",
    "participants.bulk.offers-helper": "{{count}} partecipanti selezionati. Invia le offerte dal dettaglio del partecipante (Apri dettaglio).",
    "participants.bulk.select-first": "Seleziona almeno un partecipante.",
    "participants.bulk.send-certificates": "Invia attestati",
    "participants.bulk.send-offer": "Invia offerta",
    "participants.filter-result-summary": "{{shown}} di {{total}} partecipanti",
    "participants.filters": "Filtri partecipanti",
    "participants.search-placeholder": "Nome, azienda o email",
    "participation-fee-type": "Tipo di quota di partecipazione",
    "participation-offer": "Offerta di partecipazione",
    "participation-offer-renew-failed": "Impossibile inviare l'offerta sostitutiva.",
    "participation-offer-renew-success": "Offerta sostitutiva inviata.",
    "password-recovery-requested-title": "Controlla la tua email",
    "password-recovery-success-help": "Se l'account organizzatore esiste, sono state inviate le istruzioni per il recupero della password.",
    "passwords-do-not-match": "Le password non corrispondono.",
    "payee-address": "Indirizzo del beneficiario",
    "payee-address-required": "L'indirizzo del beneficiario è obbligatorio.",
    "payee-iban-required": "L'IBAN è obbligatorio.",
    "payee-name-required": "Il nome dell'azienda/beneficiario è obbligatorio.",
    "payee-oib-required": "L'OIB è obbligatorio.",
    "payer-address": "Indirizzo del pagante",
    "payer-city": "Città del pagante",
    "payer-contact-person": "Referente",
    "payer-country": "Paese del pagante",
    "payer-create": "Aggiungi pagante",
    "payer-create-success": "Pagante aggiunto.",
    "payer-delete-failed": "Impossibile eliminare il pagante.",
    "payer-delete-success": "Pagante eliminato.",
    "payer-edit": "Modifica pagante",
    "payer-email": "Email del pagante",
    "payer-name": "Nome / persona",
    "payer-phone": "Telefono del pagante",
    "payer-save-failed": "Impossibile salvare il pagante.",
    "payer-save-success": "Pagante salvato.",
    "payer-search-placeholder": "Cerca per nome, email o OIB",
    "payer-tax-id": "OIB del pagante",
    "payer-type": "Tipo di pagante",
    "payer-type-company": "Azienda",
    "payer-type-individual": "Persona fisica",
    "payer-type-sponsor": "Sponsor",
    "payers": "Paganti",
    "payers-description": "Cerca e modifica il catalogo globale dei paganti.",
    "payment-allocation": "Allocazione del pagamento",
    "payment-deadline": "Scadenza di pagamento",
    "payment-entry-amount": "Importo ricevuto",
    "payment-entry-bank": "Bonifico bancario",
    "payment-entry-cash": "Contanti",
    "payment-entry-close": "Chiudi",
    "payment-entry-date": "Data del pagamento",
    "payment-entry-failed": "Impossibile salvare il pagamento.",
    "payment-entry-help": "Registra un pagamento effettivamente ricevuto. L'importo viene allocato all'offerta selezionata e contrassegnato come riconciliato manualmente. Sono ammessi pagamenti parziali; l'importo non può superare il saldo residuo.",
    "payment-entry-method": "Metodo di pagamento",
    "payment-entry-no-offers": "Per questo pagante non sono disponibili offerte correnti con importo da pagare.",
    "payment-entry-note": "Nota / base della conferma",
    "payment-entry-offer": "Offerta",
    "payment-entry-offer-total": "Totale dell'offerta",
    "payment-entry-positive": "Inserisci un importo maggiore di zero.",
    "payment-entry-reference": "Riferimento del pagamento",
    "payment-entry-refresh-failed": "Il pagamento è stato salvato, ma non è stato possibile aggiornare l'elenco. Chiudi questa finestra e aggiorna la pagina. Non registrare di nuovo questo pagamento.",
    "payment-entry-required": "Campo obbligatorio.",
    "payment-entry-save": "Salva pagamento",
    "payment-entry-sponsor": "Sponsor",
    "payment-entry-title": "Registra pagamento",
    "payment-method-bank-transfer": "Bonifico bancario",
    "payment-method-card": "Carta (Stripe)",
    "payment-method-category-accommodation": "Alloggio",
    "payment-method-category-accommodation-description": "Usato per le offerte di prenotazione di hotel e camere.",
    "payment-method-category-participation": "Partecipazione e opzioni",
    "payment-method-category-participation-description": "Usato per quote di partecipazione e opzioni di iscrizione a pagamento.",
    "payment-method-pos": "POS",
    "payment-methods": "Metodi di pagamento",
    "payment-reconciliation": "Riconciliazione dei pagamenti",
    "payment-records": "Registrazioni di pagamento",
    "payment-reference-value": "Riferimento {{reference}}",
    "payment-state": "Stato del pagamento",
    "payment-status": "Stato dei pagamenti",
    "payment-total": "Totale pagamenti",
    "pending": "In attesa",
    "period": "Periodo",
    "persisted-settings": "Salvato",
    "phone": "Telefono",
    "place-required": "La località è obbligatoria.",
    "preview": "Anteprima",
    "price": "Prezzo",
    "price-effect": "Effetto sul prezzo",
    "price-per-night": "Prezzo per notte",
    "pricing-periods": "Periodi di prezzo",
    "privacy-consent-event-id": "ID evento del consenso",
    "privacy-consent-missing": "Mancante",
    "privacy-consent-recorded": "Registrato",
    "privacy-consent-version": "Versione",
    "profile": "Profilo",
    "profile-error": "Il profilo non è al momento disponibile.",
    "profile-load-error-title": "Profilo non disponibile",
    "profile-save-success": "Profilo salvato.",
    "provider": "Fornitore",
    "provider-reference": "Riferimento del fornitore",
    "public-asset-mode": "Formato degli allegati pubblici",
    "public-event-forms.activate-basic": "Attiva modulo di base",
    "public-event-forms.activation-description": "Attiva un modulo di base per iniziare ad accettare iscrizioni pubbliche.",
    "public-event-forms.activation-failed": "Impossibile attivare il modulo di iscrizione.",
    "public-event-forms.activation-settings-required": "Completa nome, date e testo pubblico dell'evento prima di attivare le iscrizioni.",
    "public-event-forms.activation-success": "Il modulo di iscrizione è attivo.",
    "public-event-forms.explainer-active": "L'URL ospitato usa sempre la configurazione attuale dell'evento.",
    "public-event-forms.explainer-live-setup": "Prezzi, metodi di pagamento, alloggio, disponibilità camere, attività e testi pubblici restano aggiornati dalla configurazione.",
    "public-event-forms.explainer-title": "Cosa usa il modulo pubblico",
    "public-event-forms.readiness-activation-needed": "Crea e attiva il modulo di base prima di condividere il link ospitato.",
    "public-event-forms.readiness-basics-needed": "Salva nome, date e testo pubblico dell'evento nelle Impostazioni prima di condividere il link ospitato.",
    "public-event-forms.readiness-check-failed": "Impossibile verificare lo stato del modulo di iscrizione. Riprova prima di condividere il link.",
    "public-event-forms.readiness-checking": "Verifica",
    "public-event-forms.readiness-checking-description": "Verifica in corso della presenza di un modulo di iscrizione pubblico attivo per questo evento.",
    "public-event-forms.readiness-inactive": "Inattivo",
    "public-event-forms.readiness-options-optional": "Attività e servizi aggiuntivi sono facoltativi e compaiono solo se attivati.",
    "public-event-forms.readiness-options-ready": "{{count}} attività o servizi aggiuntivi attivi compaiono già nel modulo pubblico.",
    "public-event-forms.readiness-payment-needed": "Salva i metodi di pagamento della quota nelle impostazioni dell'evento prima di condividere il link ospitato.",
    "public-event-forms.readiness-rooming-optional": "L'alloggio è facoltativo. Il modulo pubblico resta più semplice finché le camere non sono configurate.",
    "public-event-forms.readiness-rooming-ready": "{{hotels}} hotel, {{roomTypes}} tipologie di camera e {{allotments}} disponibilità sono attivi per l'iscrizione.",
    "public-event-forms.readiness-rooming-review": "L'alloggio è visibile, ma completa hotel, tipologie di camera e disponibilità prima di condividere le camere.",
    "public-event-forms.readiness-share-ready": "Il link di iscrizione ospitato è pronto. Le modifiche alla configurazione appaiono subito.",
    "public-invitation-company": "Azienda",
    "public-invitation-dates": "Date",
    "public-invitation-error-help": "Verifica di aver aperto il link completo dalla tua email oppure contatta l'organizzatore dell'evento.",
    "public-invitation-help": "Mostra il codice QR della tua email al desk di registrazione. Aprire questa pagina non modifica lo stato della tua iscrizione.",
    "public-registration-details-title": "Dettagli dell'iscrizione",
    "public-registration-details-help": "Riceverai l'invito QR via email quando l'organizzatore ti inviterà; mostralo al desk di registrazione. Aprire questa pagina non modifica lo stato della tua iscrizione.",
    "public-invitation-invalid": "Questo link di invito non è valido o non è più attivo.",
    "public-invitation-loading": "Verifica del tuo invito in corso",
    "public-invitation-location": "Luogo",
    "public-invitation-on-site-instructions": "Istruzioni in loco",
    "public-invitation-participant": "Partecipante",
    "public-invitation-status": "Stato",
    "public-invitation-status-confirmed": "Confermato",
    "public-invitation-status-invited": "Invitato",
    "public-invitation-status-registered": "Registrato",
    "public-invitation-status-rejected": "Rifiutato",
    "public-invitation-status-submitted": "Inviato",
    "public-invitation-title": "Invito all'evento",
    "public-invitation-unavailable": "Al momento non è possibile verificare il tuo invito.",
    "public-registration-copy": "Testo dell'iscrizione pubblica",
    "public-registration-copy-iframe": "Copia iframe",
    "public-registration-embed-allowlist": "Domini consentiti per l'incorporamento",
    "public-registration-embed-allowlist-description": "Domini da cui è consentito incorporare il modulo pubblico.",
    "public-registration-hosted-url": "URL di iscrizione ospitato",
    "public-registration-iframe-snippet": "Snippet di incorporamento iframe",
    "push-channel-not-active": "Push non attivo",
    "qr-active": "Attivo",
    "qr-eligible": "Pronto",
    "qr-email-queued": "L'email QR è in attesa di consegna.",
    "qr-event-setup-incomplete": "Completa la configurazione dell'evento prima di inviare il QR",
    "qr-image-load-failed": "Impossibile caricare l'immagine QR.",
    "qr-image-loading": "Caricamento del codice QR",
    "qr-image-retry": "Ricarica immagine QR",
    "qr-image-unavailable": "L'immagine di questo invito non è disponibile. Invia di nuovo l'invito per creare un nuovo codice QR.",
    "qr-ineligible-status-reason": "Disponibile solo per iscrizioni inviate, rifiutate o invitate",
    "qr-invalid-email": "Inserisci un'email valida del partecipante prima di inviare il QR",
    "qr-invitation": "Invito QR",
    "qr-invitation-image": "Codice QR dell'invito",
    "qr-invitation-send-failed": "Impossibile inviare l'invito QR",
    "qr-invitation-sent": "Invito QR in coda",
    "qr-missing-email": "Aggiungi un'email del partecipante prima di inviare il QR",
    "qr-not-eligible": "Non pronto",
    "qr-not-ready": "Non pronto",
    "qr-ready-to-resend": "Il QR attivo può essere inviato di nuovo",
    "qr-ready-to-send": "Pronto per l'invio",
    "qr-revoked-count": "Revocato",
    "qr-view": "Visualizza codice QR",
    "question-type": "Tipo di domanda",
    "queued": "In coda",
    "reactivate": "Riattiva",
    "readiness": "Preparazione",
    "reconciled": "Riconciliato",
    "reconciled-at": "Riconciliato il",
    "registration": "Iscrizione",
    "registration-code": "Codice di iscrizione",
    "registration-codes": "Codici di iscrizione",
    "registration-count": "{{count}} iscrizioni",
    "registration-lifecycle": "Ciclo di vita dell'iscrizione",
    "registration-lifecycle.odbijen": "Rifiutato",
    "registration-lifecycle.potvrden": "Confermato",
    "registration-lifecycle.pozvan": "Invitato",
    "registration-lifecycle.prijavljen": "Inviato",
    "registration-lifecycle.registriran": "Registrato",
    "registration-options-help-description": "Usa questo elenco per attività o servizi aggiuntivi mostrati nella pagina di iscrizione pubblica in Opzioni aggiuntive. Le opzioni a pagamento attive creano voci d'offerta; le domande solo di sondaggio restano fuori dalla configurazione.",
    "registration-options-help-title": "Le opzioni di iscrizione sono servizi aggiuntivi operativi.",
    "registration-state": "Stato dell'iscrizione",
    "registration-status": "Stato dell'iscrizione",
    "registration-vat": "IVA su partecipazione e attività",
    "registration-vat-default": "IVA predefinita sulla partecipazione",
    "registration-vat-required": "L'IVA dell'iscrizione è obbligatoria.",
    "registrations-rooming": "Iscrizioni e prenotazioni camere",
    "reject-registration": "Rifiuta",
    "release": "Rilascia",
    "release-room-reservation-confirm-description": "Verrà rilasciata solo la prenotazione della camera. Il partecipante e l'iscrizione restano nell'evento.",
    "release-room-reservation-confirm-title": "Rilasciare questa prenotazione di camera?",
    "renew-participation-offer-confirm": "Sostituire questa offerta di partecipazione scaduta con i prezzi attualmente validi?",
    "replace-customer-purchase-order": "Sostituisci ordine d'acquisto",
    "replace-expired-offer": "Sostituisci offerta scaduta",
    "request-certificate": "Richiedi attestato",
    "requested": "Richiesto",
    "requires-registriran": "Richiede lo stato Registrato",
    "requires-registriran-and-completed-event": "Richiede lo stato Registrato o Confermato e un evento concluso",
    "resend": "Invia di nuovo",
    "resend-qr": "Invia di nuovo il QR",
    "resend-verification-email": "Invia di nuovo la verifica",
    "reservation-count": "{{count}} prenotazioni",
    "reservation-with-id": "Prenotazione #{{reservationId}}",
    "reservations": "Prenotazioni",
    "reserved": "Prenotato",
    "reserved-room-nights": "Pernottamenti prenotati",
    "reserved-rooms": "Camere prenotate",
    "reserved-rooms-count": "{{count}} camere prenotate",
    "reset-password": "Reimposta password",
    "retry": "Riprova",
    "review": "Verifica",
    "revoked": "Revocato",
    "revoked-codes": "Codici revocati",
    "revoked-codes-count": "{{count}} codici revocati",
    "room": "Camera",
    "room-allotments-help-description": "Seleziona hotel e tipologia di camera, poi inserisci il periodo, il numero totale di camere disponibili per quelle notti e una scadenza di pagamento facoltativa. Le iscrizioni pubbliche consumano questa disponibilità prima del pagamento e non possono superare le camere rimanenti.",
    "room-allotments-help-title": "Le disponibilità camere sono l'inventario dell'evento.",
    "room-allotments.hotels-missing": "Per questo evento non ci sono ancora hotel. Aggiungi prima hotel e tipologie di camera nella configurazione.",
    "room-allotments.room-types-missing": "Per questo evento non ci sono ancora tipologie di camera. Aggiungile prima nella configurazione.",
    "room-allotments.select-event-before-create": "Seleziona un evento prima di creare disponibilità camere.",
    "room-count": "Numero di camere",
    "room-reservation-choice": "Hotel / camera",
    "room-reservation-count": "{{count}} prenotazioni",
    "room-reservation-release-failed": "Impossibile rilasciare la prenotazione della camera.",
    "room-reservation-released": "Prenotazione della camera rilasciata.",
    "room-reservations": "Prenotazioni camere",
    "room-type": "Tipologia di camera",
    "room-type-unavailable": "Tipologia di camera non disponibile",
    "room-types": "Tipologie di camera",
    "room-types-help-description": "Inserisci il tipo di camera offerto dall'hotel: nome, capacità per camera, prezzo per notte, IVA e descrizione. Il numero di camere disponibili per l'evento non va inserito qui ma nelle disponibilità camere.",
    "room-types-help-title": "Le tipologie di camera sono il catalogo dell'hotel.",
    "rooming": "Rooming",
    "rooming-csv": "CSV rooming",
    "rooming-csv-download-error": "Impossibile scaricare il CSV rooming. Riprova.",
    "rooming-csv-download-success": "CSV rooming scaricato.",
    "rooming-export-history": "Storico esportazioni CSV rooming",
    "rooming-export-minimal-fields": "Esportazione solo alloggio",
    "rooming-list": "Elenco rooming",
    "rooming-operations": "Rooming alloggi",
    "rooming-scope-description": "Usa questo elenco e il CSV per partecipante, hotel, tipologia di camera, date di soggiorno e stato del pagamento dell'alloggio. Rilasciando una prenotazione il partecipante resta nell'evento.",
    "rooming-scope-message": "Questo elenco mostra solo l'alloggio.",
    "row-actions": "Azioni di riga",
    "save-accommodation": "Salva alloggio",
    "save-activities": "Salva attività",
    "save-participant-details": "Salva dati del partecipante",
    "save-payer": "Salva pagante",
    "save-payment-methods": "Salva metodi di pagamento",
    "save-profile": "Salva profilo",
    "save-registration": "Salva iscrizione",
    "select-accommodation-status": "Seleziona alloggio",
    "select-certificate-status": "Seleziona attestato",
    "select-event": "Seleziona evento",
    "select-event-to-view-participant-export-history": "Seleziona un evento per visualizzare lo storico esportazioni dei partecipanti.",
    "select-event-to-view-rooming-export-history": "Seleziona un evento per visualizzare lo storico esportazioni rooming.",
    "select-event-to-view-rooming-list": "Seleziona un evento per visualizzare i dettagli del rooming.",
    "select-fee-status": "Seleziona quota",
    "select-payer": "Seleziona pagante",
    "select-payer-placeholder": "Cerca per nome, email o codice fiscale",
    "select-qr-status": "Seleziona stato QR",
    "select-registration-status": "Seleziona stato",
    "selected-event": "Evento selezionato",
    "send-offer": "Invia offerta",
    "send-qr": "Invia QR",
    "sent-timeline": "Inviato: {{value}}",
    "settings-source": "Origine delle impostazioni",
    "setup-flow.accommodation": "Alloggio",
    "setup-flow.accommodation-description": "Hotel, tipologie di camera, disponibilità, scadenze di pagamento e preparazione del rooming.",
    "setup-flow.accommodation-optional": "Facoltativo se l'evento non offre camere",
    "setup-flow.accommodation-ready": "{{count}} hotel configurati",
    "setup-flow.activities": "Attività e opzioni",
    "setup-flow.activities-description": "Opzioni e attività a pagamento/gratuite da mostrare nel flusso di iscrizione.",
    "setup-flow.activities-optional": "Facoltativo se l'evento non ha servizi aggiuntivi",
    "setup-flow.activities-ready": "{{count}} opzioni attive",
    "setup-flow.basic": "Dati di base e grafiche",
    "setup-flow.basic-data-missing": "L'identità visiva è presente; i dati di base richiedono ancora attenzione",
    "setup-flow.basic-description": "Identità dell'evento, date, contenuti pubblici, istruzioni in loco e grafiche.",
    "setup-flow.basic-missing": "Dati di base e identità visiva richiedono ancora attenzione",
    "setup-flow.basic-ready": "Dati di base e grafiche sono pronti",
    "setup-flow.basic-visuals-missing": "I dati di base sono pronti; l'identità visiva richiede ancora attenzione",
    "setup-flow.description": "Segui l'ordine di configurazione necessario agli operatori ATI prima di condividere l'iscrizione pubblica.",
    "setup-flow.done": "Pronto",
    "setup-flow.kicker": "Configurazione guidata dell'evento",
    "setup-flow.load-error": "Impossibile caricare il flusso di configurazione",
    "setup-flow.open-accommodation": "Apri alloggio",
    "setup-flow.open-activities": "Apri attività",
    "setup-flow.open-full-setup": "Apri configurazione",
    "setup-flow.open-overview": "Apri panoramica",
    "setup-flow.open-pricing": "Apri prezzi",
    "setup-flow.open-registration-form": "Apri iscrizione",
    "setup-flow.open-settings": "Apri impostazioni",
    "setup-flow.optional": "Facoltativo",
    "setup-flow.pricing": "Prezzi",
    "setup-flow.pricing-current-fee-missing": "Esistono prezzi delle quote, ma nessuno è valido oggi. Verifica che il periodo di prezzo includa la data odierna.",
    "setup-flow.pricing-description": "Periodi, tipi di quota e prezzi. I metodi di pagamento restano nelle impostazioni dell'evento.",
    "setup-flow.pricing-disabled": "La quota di partecipazione è disattivata per questo evento.",
    "setup-flow.pricing-fee-prices-missing": "Collega ogni tipo di quota a un periodo di prezzo aggiungendo i prezzi delle quote.",
    "setup-flow.pricing-missing": "Aggiungi tipi di quota e periodi di prezzo oppure conferma che l'evento non prevede quota di partecipazione.",
    "setup-flow.pricing-payment-methods-missing": "I prezzi delle quote sono pronti, ma i metodi di pagamento della quota non sono ancora salvati. Salva bonifico/carta prima di condividere il modulo pubblico.",
    "setup-flow.pricing-ready": "{{feeTypes}} tipi di quota · {{periods}} periodi · {{prices}} prezzi validi oggi",
    "setup-flow.registration": "Modulo di iscrizione",
    "setup-flow.registration-description": "Condividi il link di iscrizione pubblico ospitato o l'iframe e mantieni il modulo attivo pronto per i partecipanti.",
    "setup-flow.registration-missing": "Verifica",
    "setup-flow.registration-ready": "Pronto",
    "setup-flow.required-ready": "passaggi obbligatori pronti",
    "setup-flow.review": "Verifica e avvia",
    "setup-flow.review-description": "Verifica la preparazione della configurazione e il link di iscrizione prima dell'avvio delle operazioni.",
    "setup-flow.review-form-missing": "Verifica il link di iscrizione prima di condividere l'iscrizione",
    "setup-flow.review-missing": "Completa prima i passaggi obbligatori",
    "setup-flow.review-ready": "Configurazione di base e link di iscrizione sono pronti",
    "setup-flow.title": "Costruisci l'evento nell'ordine previsto dagli organizzatori",
    "setup-flow.todo": "Incompleto",
    "setup-sequence.accommodation-description": "Configurazione facoltativa di hotel, tipologie di camera, disponibilità, prezzi e scadenze di pagamento. L'iscrizione pubblica consuma la disponibilità di camere dell'evento prima del pagamento.",
    "setup-sequence.accommodation-plan-description": "Aggiungi prima i nomi degli hotel, poi le tipologie di camera prenotabili e infine la disponibilità camere e le scadenze di pagamento usate dall'iscrizione.",
    "setup-sequence.accommodation-plan-title": "Configura l'alloggio in ordine",
    "setup-sequence.accommodation-title": "Alloggio",
    "setup-sequence.activities-plan-description": "Qui vanno solo attività e servizi aggiuntivi che influiscono su iscrizione, presenza o pagamento. Le domande solo di sondaggio restano fuori dalla configurazione.",
    "setup-sequence.activities-plan-title": "Mantieni questo passaggio sui servizi aggiuntivi selezionabili",
    "setup-sequence.activities-title": "Attività/servizi aggiuntivi",
    "setup-sequence.basic-description": "Imposta identità dell'evento, date, contenuti pubblici in croato e inglese, grafiche/documenti, valori fiscali, metodi di pagamento e testi email prima di condividere il modulo.",
    "setup-sequence.basic-title": "Dati di base",
    "setup-sequence.pricing-description": "L'indicazione della quota e i metodi di pagamento restano nelle impostazioni dell'evento. Usa questa pagina per periodi di prezzo, tipi di quota e prezzi.",
    "setup-sequence.pricing-no-fee-description": "Puoi lasciare vuoti periodi, tipi di quota e righe di prezzo. Torna qui solo se l'evento inizia a riscuotere quote.",
    "setup-sequence.pricing-no-fee-title": "Questo evento non prevede una quota di partecipazione",
    "setup-sequence.pricing-plan-description": "Aggiungi periodi di prezzo, tipi di quota e le righe di prezzo che li collegano.",
    "setup-sequence.pricing-plan-title": "In questo passaggio procedi dall'alto verso il basso",
    "setup-sequence.pricing-title": "Quote",
    "setup-sequence.registration-title": "Modulo di iscrizione",
    "setup-sequence.settings-plan-description": "Salva prima i dati di base, poi verifica i valori fiscali e i testi delle email ai partecipanti prima di condividere il link di iscrizione.",
    "setup-sequence.settings-plan-title": "Completa questo passaggio in tre fasi",
    "sponsor-covered": "Coperto dallo sponsor",
    "sponsor-payment": "Pagamento dello sponsor",
    "sponsored": "Sponsorizzato",
    "start-date-required": "La data di inizio è obbligatoria.",
    "stay": "Soggiorno",
    "stored-file": "File salvato",
    "stored-offer-history": "Storico delle offerte salvate",
    "stripe-open-payment": "Apri pagina di pagamento",
    "stripe-payment-link": "Link di pagamento Stripe",
    "stripe-payment-link-help": "Apri la pagina di pagamento o copia il link da condividere con il pagante. I link scadono dopo 30 giorni.",
    "stripe-payment-unavailable": "Pagamento online non disponibile",
    "stripe-payment-unavailable-help": "Verifica che Stripe sia configurato, che l'offerta sia valida e che i pagamenti con carta siano attivi per questo evento.",
    "stripe-refunded": "Rimborsato",
    "subject": "Oggetto",
    "successfully-saved-item": "Elemento salvato correttamente",
    "system-data-title": "Dati di sistema",
    "tax": "Imposta",
    "tax-scheme": "Regime fiscale",
    "tax-scheme-ppo": "PPO / IVA 0%",
    "tax-scheme-required": "Il regime fiscale è obbligatorio.",
    "tax-scheme-standard-vat": "IVA standard",
    "template": "Modello",
    "template-field": "Campo",
    "template-field-add": "Aggiungi campo",
    "template-field-background-color": "Sfondo",
    "template-field-background-opacity": "Opacità dello sfondo",
    "template-field-border-color": "Bordo",
    "template-field-border-opacity": "Opacità del bordo",
    "template-field-border-radius": "Raggio",
    "template-field-border-width": "Spessore del bordo",
    "template-field-collapse": "Nascondi parametri",
    "template-field-color": "Colore del testo",
    "template-field-expand": "Modifica parametri",
    "template-field-font-family": "Carattere",
    "template-field-font-size": "Dimensione del carattere",
    "template-field-font-style": "Stile",
    "template-field-font-style-italic": "Corsivo",
    "template-field-font-style-normal": "Normale",
    "template-field-font-weight": "Spessore",
    "template-field-label": "Etichetta",
    "template-field-participant-field": "Campo partecipante",
    "template-field-position-x": "Posizione X",
    "template-field-position-y": "Posizione Y",
    "template-field-remove": "Rimuovi campo",
    "template-field-shadow": "Ombra",
    "template-field-size": "Dimensione",
    "template-field-source": "Origine",
    "template-field-source-participant": "Partecipante",
    "template-field-source-static": "Testo statico",
    "template-field-static-sample": "Testo",
    "template-field-static-text": "Testo statico",
    "template-field-type": "Tipo",
    "template-field-type-qr": "Codice QR",
    "template-field-type-text": "Testo",
    "template-fields": "Campi",
    "template-preview-download": "Scarica anteprima",
    "templates": "Modelli",
    "timestamp": "Data e ora",
    "title": "Titolo",
    "total": "Totale",
    "totals": "Totali",
    "unallocated": "Non allocato",
    "unknown-participant": "Partecipante sconosciuto",
    "upload-customer-purchase-order": "Carica ordine d'acquisto",
    "upload-file": "Carica file",
    "validation.complete-required-fields": "Controlla i campi obbligatori e riprova.",
    "validation.correct-invalid-values": "Controlla i valori inseriti e riprova.",
    "vat": "IVA",
    "verification-email": "Email di verifica",
    "verification-email-queue-failed": "Impossibile mettere in coda l'email di verifica.",
    "verification-email-queued": "Email di verifica in coda.",
    "verified": "Verificato",
    "verified-registration-count": "{{count}} di {{total}} verificati",
    "view": "Visualizza",
    "enums:QUEUED": "In coda",
    "app-shell.account-menu": "Menu account",
    "app-shell.breadcrumb": "Percorso di navigazione",
    "app-shell.close-menu": "Chiudi menu",
    "app-shell.home": "ATIventura - home",
    "app-shell.language": "Lingua",
    "app-shell.main-navigation": "Navigazione principale",
    "app-shell.open-menu": "Apri menu",
    "event-payments.actions": "Azioni",
    "event-payments.amount": "Importo",
    "event-payments.balance-paid": "Pagato",
    "event-payments.balance-partial": "Pagato parzialmente",
    "event-payments.balance-unpaid": "Non pagato",
    "event-payments.due-date": "Scadenza",
    "event-payments.empty": "Nessuna offerta per questo evento",
    "event-payments.filter": "Filtro offerte",
    "event-payments.filter-all": "Tutte, incluse le sostituite",
    "event-payments.filter-current": "Offerte correnti",
    "event-payments.filter-outstanding": "Da pagare",
    "event-payments.filter-paid": "Pagate",
    "event-payments.load-failed": "Impossibile caricare offerte e pagamenti.",
    "event-payments.offer": "Offerta",
    "event-payments.open-payer": "Apri pagante",
    "event-payments.outstanding": "Residuo",
    "event-payments.overdue": "Scaduto",
    "event-payments.paid": "Pagato",
    "event-payments.participant": "Partecipante",
    "event-payments.payer": "Pagante",
    "event-payments.search": "Cerca offerta, partecipante o pagante",
    "event-payments.status": "Stato dell'offerta",
    "event-payments.type": "Tipo",
    "event-workspace.payments": "Pagamenti",
    "change-payer": "Cambia pagatore",
    "participant-payer-chosen-at-registration": "Il pagatore viene scelto al momento dell'iscrizione del partecipante.",
    "participant-payer-locked": "A questo pagatore è già stata emessa un'offerta, quindi il pagatore non può essere cambiato.",
    "participant-payer-required": "Seleziona prima un pagatore.",
    "participant-payer-change-success": "Pagatore cambiato.",
    "participant-payer-change-failed": "Non è stato possibile cambiare il pagatore.",
    "organizer-registration.title": "Iscrivi partecipante",
    "organizer-registration.submit": "Iscrivi",
    "organizer-registration.payer-mode-new": "Nuovo pagatore",
    "organizer-registration.payer-mode-existing": "Pagatore esistente",
    "organizer-registration.payer-required": "Seleziona un pagatore.",
    "organizer-registration.verification-note": "Il partecipante riceve un'e-mail per confermare l'indirizzo. L'offerta viene inviata dopo la conferma, come per l'iscrizione pubblica.",
    "organizer-registration.success": "Il partecipante è iscritto. È stata inviata un'e-mail per confermare l'indirizzo.",
    "organizer-registration.unavailable": "Iscrizione non possibile: l'evento è concluso o non ha un modulo di iscrizione attivo.",
    "organizer-registration.load-failed": "Non è stato possibile caricare il modulo di iscrizione.",
    "qr-email-not-confirmed": "Il partecipante non ha ancora confermato l'indirizzo e-mail",
    "enums:PRIJAVLJEN": "Iscritto",
    "enums:ODBIJEN": "Rifiutato",
    "enums:POZVAN": "Invitato",
    "enums:REGISTRIRAN": "Registrato",
    "enums:POTVRDEN": "Confermato",
    "validation-required": "Campo obbligatorio",
    "validation-invalid-email": "Inserisci un indirizzo e-mail valido.",
    "validation-invalid-phone": "Inserisci un numero di telefono valido.",
    "validation-invalid-linkedin": "Inserisci l'URL di un profilo LinkedIn.",
    "event-config-delete-accommodation-options-none": "Seleziona almeno un tipo di camera da eliminare.",
    "template-event-data-unavailable": "I dati dell'evento non sono ancora caricati, quindi il modello non può essere salvato. Ricarica la pagina e riprova.",
    "notifications-send-reason-event": "Apri prima un evento.",
    "notifications-send-reason-recipients": "Seleziona almeno un destinatario.",
    "notifications-send-reason-channel": "Seleziona un canale.",
    "notifications-send-reason-content": "Scrivi il contenuto del messaggio.",
    "notifications-send-reason-subject": "Inserisci l'oggetto dell'e-mail.",
    "notifications-send-reason-reply-to": "Inserisci un indirizzo di risposta o disattiva la risposta."
}
